// src/data/vetResources.js

export const resourceCategories = [
  "Government Agencies and Services",
  "Crisis Support",
  "Mental Health and SUD",
  "Housing and Homelessness Assistance",
  "Benefits, Claims, and Financial Assistance",
  "Employment and Career Services",
  "Veteran Service Organizations and Advocacy",
  "Legal Services",
  "Online Resources and Support Groups",
];

export const counties = [
  "All",
  "Belknap",
  "Carroll",
  "Cheshire",
  "Coös",
  "Grafton",
  "Hillsborough",
  "Merrimack",
  "Rockingham",
  "Strafford",
  "Sullivan",
];

// Helper functions
export const getResourcesByCategory = (category) => {
  return resources.filter((resource) =>
    Array.isArray(resource.category)
      ? resource.category.includes(category)
      : resource.category === category,
  );
};

export const getResourcesByCounty = (county) => {
  if (county === "All") return resources;
  return resources.filter(
    (resource) =>
      resource.counties.includes("All") || resource.counties.includes(county),
  );
};

export const getResourcesByCategoryAndCounty = (category, county) => {
  let filtered = resources.filter((resource) =>
    Array.isArray(resource.category)
      ? resource.category.includes(category)
      : resource.category === category,
  );
  if (county !== "All") {
    filtered = filtered.filter((resource) =>
      resource.counties.includes("All") || resource.counties.includes(county),
    );
  }
  return filtered;
};

export const resources = [
  // Government Agencies and Services
  {
    id: 1,
    name: "Department of Military Affairs and Veterans Services",
    category: "Government Agencies and Services",
    counties: ["All", "Merrimack"],
    address: "1 Minuteman Way, Concord, NH 03301",
    phone: "(603) 225-1200",
    website: "https://www.dmavs.nh.gov",
    email: "",
    services: [
      "State veterans benefits and services",
      "Claims assistance (through NH Veterans Services Officers)",
      "State Veterans Cemetery information",
      "Resource navigation and referrals",
    ],
    description:
      "New Hampshire’s Department of Military Affairs & Veterans Services (DMAVS) oversees statewide veterans services, including assistance with accessing benefits and coordination with partner programs.",
    notes:
      "Headquarters address and main phone verified on DMAVS; cemetery is a DMAVS division. For VSO appointments, see NH Division of Veterans Services (below).",
  },
  {
    id: 2,
    name: "VA (NH)",
    category: "Government Agencies and Services",
    counties: ["All", "Hillsborough"],
    address: "718 Smyth Rd, Manchester, NH 03104",
    phone: "(603) 624-4366",
    website: "https://www.va.gov/manchester-health-care/",
    email: "",
    services: [
      "Primary & specialty health care",
      "Mental health & substance use treatment",
      "Women Veterans health services",
      "Caregiver support and whole-health services",
    ],
    description:
      "VA Manchester Healthcare System is the main VA medical facility serving New Hampshire Veterans, offering comprehensive medical, mental health, and specialty care.",
    notes:
      "Health care facility only. For disability compensation and benefits claims, use the VA Manchester Regional Benefit Office (Norris Cotton Federal Building, 275 Chestnut St, Manchester).",
  },
  {
    id: 3,
    name: "New Hampshire Office of Veterans Services",
    category: "Government Agencies and Services",
    counties: ["All", "Hillsborough"],
    address: "275 Chestnut St, Room 517, Manchester, NH 03101-2411",
    phone: "(603) 624-9230",
    website: "https://www.dmavs.nh.gov/veterans-services",
    email: "",
    services: [
      "Claims and appeals assistance",
      "Benefits counseling",
      "Veterans Services Officer (VSO) appointments",
      "Referrals to state and federal programs",
    ],
    description:
      "The state’s Division of Veterans Services assists NH Veterans and dependents with applying for and managing federal and state benefits via trained Veterans Services Officers.",
    notes:
      "Toll-free (NH only): 1-800-622-9230. Fax listed publicly as (603) 624-9236. Call to schedule VSO appointments statewide.",
  },
  {
    id: 4,
    name: "NH Veteran Resource Directory",
    category: "Government Agencies and Services",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "",
    website:
      "https://www.dmavs.nh.gov/sites/g/files/ehbemt401/files/inline-documents/sonh/resource-directory2.pdf",
    email: "",
    services: [
      "Comprehensive resource directory",
      "Service provider listings",
      "Program information",
      "Contact information database",
    ],
    description:
      "Official statewide directory of veteran resources produced in partnership with NH Employment Security and DMAVS.",
    notes:
      "PDF directory maintained by the State; content includes benefits contacts, program listings, and statewide service information.",
  },
  {
    id: 5,
    name: "National Resource Directory",
    category: "Government Agencies and Services",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "",
    website: "https://nrd.gov/",
    email: "infonrd.osd@mail.mil",
    services: [
      "National veteran resource database",
      "Service locator tools",
      "Benefits information",
      "Program directories",
    ],
    description:
      "Federal, curated portal connecting Service Members, Veterans, families, and caregivers to vetted programs and services at national, state, and local levels.",
    notes:
      "A joint DoD/VA/DOL initiative; includes resources for health, housing, employment, education, and more.",
  },

  // Crisis Support / Mental Health and SUD
  {
    id: 6,
    name: "Veterans Crisis Line",
    category: "Crisis Support",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "Dial 988 (Press 1); 1-800-273-8255 (Press 1); Text 838255",
    website: "https://www.veteranscrisisline.net/",
    email: "",
    services: [
      "24/7 crisis intervention (phone, text, chat)",
      "Suicide prevention",
      "Connection to local resources and VA support",
    ],
    description:
      "Free, confidential 24/7 crisis support for Veterans, service members, and their families via phone, text, or chat.",
    notes:
      "You do not need to be enrolled in VA health care to use this service; use 988 then Press 1 for the Veterans option.",
  },

  {
    id: 44,
    name: "Manchester Vet Center (Hooksett) – Readjustment Counseling",
    category: "Mental Health and SUD",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "1461 Hooksett Rd, Suite B7, Hooksett, NH 03106",
    phone: "(603) 668-7060",
    website: "https://www.va.gov/manchester-vet-center/",
    email: "",
    services: [
      "No-cost readjustment counseling (individual & group)",
      "PTSD & Military Sexual Trauma (MST) counseling",
      "Family & couples counseling related to military service",
      "Bereavement counseling",
      "Substance use screening & community referrals",
      "Community outreach and support groups",
    ],
    description:
      "Community-based Vet Center offering confidential counseling and support to eligible Veterans, active duty service members, and their families in a non-medical setting.",
    notes:
      "Not an emergency clinic; for urgent help call the Veterans Crisis Line (988, Press 1). Outstation services available in the Seacoast area.",
  },
  {
    id: 7,
    name: "Manchester VA — Mental Health & SUD Services",
    category: [
      "Government Agencies and Services",
      "Mental Health and SUD",
    ],
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "718 Smyth Rd, Manchester, NH 03104",
    phone: "(603) 624-4366",
    website:
      "https://www.va.gov/manchester-health-care/health-services/mental-health-care/",
    email: "",
    services: [
      "Outpatient SUD treatment and counseling",
      "Medication-assisted treatment (as clinically indicated)",
      "Care coordination and referrals within VA network",
      "Access to residential/inpatient SUD options via VA Community Care when eligible",
    ],
    description:
      "VA Manchester provides Veteran-focused behavioral health with access to substance use disorder care and referrals to higher levels of care within the VA system.",
    notes:
      "VA medical centers without a dedicated SUD program still provide SUD treatment—ask for the Mental Health Clinic; additional options may be available through VA Community Care.",
  },
  {
    id: 8,
    name: "National Veterans Foundation – Lifeline for Vets",
    category: "Crisis Support",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "1-888-777-4443",
    website: "https://nvf.org/lifeline-for-vets/",
    email: "",
    services: [
      "Veteran-to-Veteran crisis and support hotline",
      "Resource navigation and referrals",
      "Assistance with benefits, housing, and mental health resources",
    ],
    description:
      "National nonprofit providing peer-to-peer support and resource referrals for Veterans and their families through the Lifeline for Vets.",
    notes:
      "Phone availability typically weekdays (PST); not a 24/7 emergency line—use 988 (Press 1) for urgent crises.",
  },

  {
    id: 10,
    name: "SAFE Project – Veterans & Military Families",
    category: "Mental Health and SUD",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "",
    website: "https://www.safeproject.us/veterans/",
    email: "",
    services: [
      "Military Wellness Program (resilience & prevention)",
      "Weekly virtual Veterans recovery meetings",
      "Toolkits, education, and community training",
    ],
    description:
      "National initiative offering Veteran-focused prevention, wellness, and recovery resources—including weekly virtual meetings and a front-end wellness program.",
    notes:
      "Online resource hub; programming is national and virtual—no NH-specific phone line listed.",
  },
  {
    id: 11,
    name: "Recovery Mountain",
    category: "Mental Health and SUD",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "100 Autumn Dr, Tilton, NH 03276",
    phone: "(603) 256-9800",
    website: "https://recoverymountainnh.com/",
    email: "",
    services: [
      "Residential addiction treatment",
      "Detox program (on-site; contact for level-of-care details)",
      "Dual-diagnosis treatment",
      "PTSD-focused therapy; programs for Veterans and first responders",
    ],
    description:
      "New Hampshire treatment center offering residential care, a detox program, and dual-diagnosis services with programming that includes Veterans and first responders.",
    notes:
      "24/7 contact line; confirm specific medical detox capabilities and admission criteria directly.",
  },

  // Housing and Homelessness Assistance
  {
    id: 12,
    name: "National Call Center for Homeless Veterans",
    category: "Housing and Homelessness Assistance",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "1-877-424-3838 (1-877-4AID-VET)",
    website: "https://www.va.gov/homeless/nationalcallcenter.asp",
    email: "",
    services: [
      "24/7 homeless veteran hotline",
      "Emergency assistance referrals",
      "Housing program information",
      "Local resource connections",
    ],
    description:
      "National VA hotline providing free, confidential, 24/7 assistance and referrals for homeless Veterans and those at risk.",
    notes:
      "Connects callers to trained VA staff and local resources; available nationwide.",
  },
  {
    id: 13,
    name: "New Hampshire Veterans Home",
    category: "Housing and Homelessness Assistance",
    counties: ["All", "Belknap"],
    address: "139 Winter St, Tilton, NH 03276",
    phone: "(603) 527-4400",
    website: "https://www.veteranshome.nh.gov/",
    email: "",
    services: [
      "Long-term nursing care",
      "Memory care (dementia/Alzheimer’s)",
      "Therapies and activities",
      "Veteran-focused residential support",
    ],
    description:
      "State Veterans Home in Tilton providing long-term nursing care and specialized memory care for eligible Veterans.",
    notes:
      "State-operated long-term care facility; contact for eligibility and admissions.",
  },
  {
    id: 14,
    name: "Harbor Care – Veterans FIRST (SSVF, Housing & Services)",
    category: "Housing and Homelessness Assistance",
    counties: ["All", "Hillsborough"],
    address: "Administrative Offices: 77 Northeastern Blvd, Nashua, NH 03062",
    phone: "(603) 882-3616",
    website: "https://harborcarenh.org/veteran-services/",
    email: "",
    services: [
      "SSVF: homelessness prevention & rapid rehousing",
      "Transitional & permanent housing programs",
      "Case management and housing navigation",
      "Employment and supportive services",
    ],
    description:
      "Harbor Care’s Veterans FIRST programs provide statewide housing assistance for Veterans and families, including SSVF prevention/rapid rehousing and supportive housing with case management.",
    notes:
      "Statewide access; SSVF direct line: (603) 305-1122. For healthcare, use Harbor Care Health & Wellness Center: (603) 821-7788.",
    contacts: [
      { type: "SSVF (statewide)", phone: "(603) 305-1122" },
      { type: "Housing & Veteran Services", phone: "(603) 882-3616" },
    ],
  },
  {
    id: 15,
    name: "VA Home Loan Guaranty Program",
    category: "Housing and Homelessness Assistance",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "1-877-827-3702 (M–F, 8am–6pm ET)",
    website: "https://www.va.gov/housing-assistance/home-loans/",
    email: "",
    services: [
      "VA-backed home loan guaranty",
      "Purchase and refinance options (e.g., IRRRL, cash-out)",
      "Native American Direct Loan (NADL)",
      "Adapted housing and related housing assistance programs",
    ],
    description:
      "VA’s Loan Guaranty and housing-related programs help eligible Veterans, service members, and surviving spouses buy, build, repair, retain, or adapt a primary residence.",
    notes:
      "Call for eligibility and COE questions; work with VA-approved lenders. TTY: 711.",
  },
  {
    id: 16,
    name: "Veterans Inc.",
    category: "Housing and Homelessness Assistance",
    counties: ["All", "Merrimack"],
    address: "10 Ferry St, Suite 404, Concord, NH 03301",
    phone: "1-800-482-2565",
    website: "https://www.veteransinc.org/",
    email: "info@veteransinc.org",
    services: [
      "SSVF rental assistance (prevention & rapid rehousing)",
      "Emergency and transitional housing",
      "Permanent supportive housing",
      "Case management, employment & training",
    ],
    description:
      "Regional nonprofit serving New England Veterans and families with housing programs (including SSVF), case management, and supportive services; NH office in Concord.",
    notes:
      "24/7 intake via toll-free line; statewide NH services coordinated from Concord office and partner sites.",
  },

  // Benefits, Claims, and Financial Assistance
  {
    id: 17,
    name: "Easterseals NH — Veterans Count (Emergency Financial & Case Mgmt)",
    category: "Benefits, Claims, and Financial Assistance",
    counties: ["All", "Hillsborough"],
    address: "555 Auburn St, Manchester, NH 03103",
    phone: "(603) 315-4354",
    website: "https://vetscount.org/help/",
    email: "",
    services: [
      "Veterans Count: case management & emergency financial assistance",
      "Transportation services (eligibility-based)",
      "Workforce development / employment supports",
      "Disability and community-based services",
    ],
    description:
      "Easterseals NH provides statewide services for veterans and families through Veterans Count (care coordination and emergency financial assistance), as well as transportation, workforce development, and disability services.",
    notes: "Contact Veterans Count Program Coordinators for services and referrals; the program's help page says someone will respond within 24 hours.",
  },
  {
    id: 18,
    name: "Disabled American Veterans (DAV)",
    category: "Benefits, Claims, and Financial Assistance",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "National HQ: 860 Dolwick Dr, Erlanger, KY 41018",
    phone: "1-877-426-2838",
    website: "https://www.dav.org/",
    email: "",
    services: [
      "Free VA claims & appeals assistance",
      "DAV Transportation Network (rides to VA facilities)",
      "Employment services & career fairs",
      "Emergency/disaster financial relief programs",
    ],
    description:
      "National VSO providing no-cost VA benefits assistance, transportation to VA medical appointments, employment supports, and limited emergency/disaster relief for veterans and families.",
    notes:
      "For transportation in NH, see VA Manchester’s DAV Vans page; financial relief available in specific programs (e.g., disaster relief or DAV Auxiliary funds).",
  },
  {
    id: 19,
    name: "Veterans of Foreign Wars (VFW)",
    category: "Benefits, Claims, and Financial Assistance",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "National HQ: 406 W 34th St, Kansas City, MO 64111",
    phone: "1-816-756-3390",
    website: "https://www.vfw.org/",
    email: "",
    services: [
      "Free VA claims assistance (VFW Service Officers)",
      "Emergency financial help (Unmet Needs program)",
      "Scholarships and community-based support",
      "Benefits education and advocacy",
    ],
    description:
      "National veterans organization offering accredited claims assistance and financial help through programs like Unmet Needs, plus local post-based support.",
    notes:
      "Member Service Center: 1-833-VFW-VETS; Unmet Needs program phone: 1-866-789-6333.",
  },
  {
    id: 20,
    name: "Military OneSource (MilTax, Counseling, Spouse Employment)",
    category: "Benefits, Claims, and Financial Assistance",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "1-800-342-9647",
    website: "https://www.militaryonesource.mil/",
    email: "",
    services: [
      "Financial counseling (no-cost)",
      "MilTax: free tax software & consultations",
      "Career coaching & spouse employment resources",
      "Relocation & benefit navigation support",
    ],
    description:
      "DoD program offering 24/7 no-cost support to eligible service members, Guard/Reserve, and families, including financial counseling and free tax filing assistance.",
    notes:
      "Canonical Military OneSource record (duplicate removed). If your UI supports cross-listing, it’s also relevant to Employment, VSOs/Advocacy, and Online Resources.",
  },

  // Employment and Career Services
  {
    id: 22,
    name: "Veteran Employment Services Office",
    category: "Employment and Career Services",
    counties: ["All", "Merrimack"],
    address: "64B Old Suncook Rd, Concord, NH 03301",
    phone: "(603) 228-4100",
    website: "https://www.nhes.nh.gov/",
    email: "",
    services: [
      "Employment assistance",
      "Job placement services",
      "Career counseling",
      "Skills assessment",
    ],
    description:
      "State employment services specifically designed to help veterans find meaningful employment.",
    notes:
      "Part of NH Employment Security. Veterans receive priority of service; use the NHES office locator for local assistance.",
  },
  {
    id: 23,
    name: "Veterans Education and Training Services",
    category: "Employment and Career Services",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "1-888-442-4551",
    website: "https://www.va.gov/education/",
    email: "",
    services: [
      "GI Bill benefits administration",
      "Education counseling",
      "Vocational rehabilitation",
      "On-the-job training programs",
    ],
    description:
      "VA education services helping veterans use their educational benefits for career advancement.",
    notes:
      "Coordinates with educational institutions throughout New Hampshire.",
  },
  {
    id: 25,
    name: "New Hampshire Veterans Education Services (DMAVS)",
    category: "Employment and Career Services",
    counties: ["All", "Merrimack"],
    address: "25 Capitol St, Concord, NH 03301",
    phone: "(603) 271-4734",
    website: "https://www.dmavs.nh.gov/",
    email: "",
    services: [
      "State education benefits",
      "Training program coordination",
      "Scholarship information",
      "Career guidance",
    ],
    description:
      "State office coordinating educational opportunities and training programs for New Hampshire veterans.",
    notes:
      "Statutory oversight transferred to DMAVS in 2025. Confirm the current direct office address and phone before visiting.",
  },

  // Veteran Service Organizations and Advocacy
  {
    id: 26,
    name: "American Legion (NH)",
    category: "Veteran Service Organizations and Advocacy",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "21 South Fruit St, Suite 266, Concord, NH 03301",
    phone: "(603) 856-8951",
    website: "https://www.legionnh.org/",
    email: "adjutantnh@legionnh.org",
    services: [
      "Veterans advocacy",
      "Community programs",
      "Youth programs",
      "Legislative advocacy",
    ],
    description:
      "Veterans organization providing advocacy, community service, and support programs throughout New Hampshire.",
    notes:
      "Over 50 posts throughout the state providing local veteran support.",
  },
  {
    id: 27,
    name: "AMVETS",
    category: "Veteran Service Organizations and Advocacy",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "Multiple post locations",
    phone: "1-877-726-8387",
    website: "https://www.amvets.org/",
    email: "",
    services: [
      "Veterans advocacy",
      "Legislative representation",
      "Community service",
      "Scholarship programs",
    ],
    description:
      "Veterans service organization advocating for veterans' rights and providing community support programs.",
    notes: "Multiple posts in New Hampshire serving all eras of veterans.",
  },

  {
    id: 29,
    name: "Vietnam Veterans of America",
    category: "Veteran Service Organizations and Advocacy",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "Multiple chapter locations",
    phone: "1-800-882-1316",
    website: "https://vva.org/",
    email: "",
    services: [
      "Vietnam veteran advocacy",
      "Agent Orange assistance",
      "PTSD support",
      "Legislative advocacy",
    ],
    description:
      "Organization dedicated to the needs and concerns of Vietnam era veterans and their families.",
    notes: "Multiple chapters throughout New Hampshire.",
  },
  {
    id: 30,
    name: "Wounded Warrior Project",
    category: "Veteran Service Organizations and Advocacy",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "1-888-997-2586",
    website: "https://www.woundedwarriorproject.org/",
    email: "",
    services: [
      "Mental health support",
      "Career counseling",
      "Long-term care support",
      "Advocacy programs",
    ],
    description:
      "National organization supporting wounded veterans through various programs and advocacy efforts.",
    notes: "Serves post-9/11 wounded veterans and their families nationwide.",
  },
  {
    id: 31,
    name: "Vets4Warriors",
    category: "Veteran Service Organizations and Advocacy",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "1-855-838-8255",
    website: "https://vets4warriors.com/",
    email: "",
    services: [
      "Peer support network",
      "24/7 helpline",
      "Resource referrals",
      "Crisis intervention",
    ],
    description:
      "Peer support network providing confidential help to veterans, service members, and their families.",
    notes: "Staffed by combat veterans and military family members.",
  },
  {
    id: 32,
    name: "Travis Mills Foundation (Maine)",
    category: "Veteran Service Organizations and Advocacy",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "747 Western Ave, Manchester, ME 04351",
    phone: "(207) 622-7451",
    website: "https://www.travismillsfoundation.org/",
    email: "",
    services: [
      "Retreat programs for wounded veterans",
      "Family support services",
      "Adaptive programs",
      "Community outreach",
    ],
    description:
      "Foundation providing support and retreat programs for wounded veterans and their families in New England.",
    notes:
      "Located in Maine but serves veterans throughout New England including New Hampshire.",
  },
  {
    id: 33,
    name: "Paralyzed Veterans of America (PVA) – New England Chapter",
    category: "Veteran Service Organizations and Advocacy",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "1208 VFW Pkwy, Suite 301, West Roxbury, MA 02132",
    phone: "(617) 942-8678; toll-free (800) 660-1181",
    website: "https://www.pvanewengland.org/",
    email: "",
    services: [
      "Spinal cord injury support",
      "Benefits advocacy",
      "Adaptive sports programs",
      "Accessibility advocacy",
    ],
    description:
      "Organization serving veterans with spinal cord injuries and diseases throughout New England.",
    notes: "Serves New Hampshire veterans from New England chapter.",
  },
  {
    id: 34,
    name: "Warriors @ 45 North (NH)",
    category: "Veteran Service Organizations and Advocacy",
    counties: ["All", "Carroll"],
    address: "North Conway, NH area",
    phone: "",
    website: "https://warriorsat45north.org/",
    email: "",
    services: [
      "Outdoor recreation programs",
      "Therapeutic activities",
      "Community building",
      "Veteran support network",
    ],
    description:
      "New Hampshire-based organization providing outdoor recreational therapy and support for veterans.",
    notes: "Focuses on outdoor activities in the White Mountains region.",
  },

  // Legal Services
  {
    id: 35,
    name: "Veterans Justice Outreach (VJO) Program",
    category: "Legal Services",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "718 Smyth Rd, Manchester, NH 03104",
    phone: "(603) 624-4366",
    website:
      "https://department.va.gov/homeless/veterans-justice-programs/veterans-justice-outreach/",
    email: "",
    services: [
      "Court advocacy for veterans",
      "Legal assistance coordination",
      "Treatment court support",
      "Criminal justice system navigation",
    ],
    description:
      "VA program assisting veterans involved in the criminal justice system with accessing treatment and other services.",
    notes: "Contact local VA medical center for VJO specialist. Website: VJO",
  },
  {
    id: 36,
    name:
      "Veterans Foundation of New Hampshire – Veterans Law Project (Legal Boots on the Ground)",
    category: "Legal Services",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "77 Central St, Manchester, NH 03101",
    phone: "(603) 716-8488",
    website: "",
    email: "vlp@vfnh.org",
    services: [
      "Civil and criminal legal advice and representation",
      "Veterans court and treatment-track support",
      "Legal assistance for eligible New Hampshire veterans",
      "Online assistance request pathway",
    ],
    description:
      "The Veterans Foundation of New Hampshire’s Veterans Law Project assists veterans with civil and criminal legal needs and supports veteran-focused tracks in the New Hampshire court system.",
    notes:
      "Submit an assistance request online or contact the Veterans Law Project helpline. Acceptance depends on legal issue, eligibility, and available capacity. The former assistance URL now redirects to the generic Veterans Foundation of New Hampshire homepage; retain program details pending a restored program-specific online intake page.",
  },

  // Online Resources and Support Groups
  {
    id: 37,
    name: "Al-Anon Electronic Meetings",
    category: "Online Resources and Support Groups",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "",
    website: "https://al-anon.org/al-anon-meetings/",
    email: "",
    services: [
      "Online Al-Anon meetings",
      "Family support groups",
      "12-step recovery program",
      "Addiction family education",
    ],
    description:
      "Online Al-Anon meetings for families and friends of those affected by addiction, including veterans.",
    notes: "Offers online Al-Anon meetings for those affected by addiction",
  },
  {
    id: 38,
    name: "In The Rooms",
    category: "Online Resources and Support Groups",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "",
    website: "https://www.intherooms.com/home/",
    email: "",
    services: [
      "Online recovery meetings",
      "12-step program support",
      "24/7 recovery community",
      "Multiple fellowship options",
    ],
    description:
      "Online platform hosting live recovery meetings and providing 24/7 support community for addiction recovery.",
    notes: "Features various recovery fellowships and meeting formats.",
  },
  {
    id: 39,
    name: "Smart Recovery Online",
    category: "Online Resources and Support Groups",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "",
    website: "https://smartrecovery.org/",
    email: "",
    services: [
      "SMART Recovery meetings",
      "Self-management tools",
      "Cognitive behavioral techniques",
      "Online support groups",
    ],
    description:
      "Alternative addiction recovery program using cognitive behavioral techniques and self-management tools.",
    notes: "Offers both online and in-person meeting options.",
  },
  // Government Agencies and Services (Additional)
  {
    id: 43,
    name: "Manchester VA Regional Benefit Office (VBA)",
    category: "Government Agencies and Services",
    counties: ["All", "Hillsborough"],
    address: "275 Chestnut St, Manchester, NH 03101",
    phone: "1-800-827-1000",
    website: "https://www.va.gov/manchester-va-regional-benefit-office/",
    email: "",
    services: [
      "VA disability compensation",
      "Pension benefits",
      "Benefits claims assistance",
      "Regional benefits hub services",
    ],
    description:
      "VA Benefits Office for NH located at the Norris Cotton Federal Building in Manchester. This office assists veterans with VA disability compensation, pensions, and other benefits claims as part of the U.S. Veterans Benefits Administration.",
    notes:
      "Serves as a regional hub for benefits assistance. Use national VA benefits line for initial contact.",
  },
  {
    id: 69,
    name: "Hiring Our Heroes (HoH)",
    category: "Employment and Career Services",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "",
    website: "https://www.hiringourheroes.org",
    email: "",
    services: [
      "Veteran hiring fairs (in-person and virtual)",
      "Corporate fellowship programs",
      "12-week skillbridge internships",
      "Connection with veteran-ready employers",
    ],
    description:
      "An initiative of the U.S. Chamber of Commerce Foundation that hosts veteran hiring fairs and corporate fellowship programs nationwide. In NH and nearby states, HoH runs frequent hiring events where veterans and military spouses can connect with employers.",
    notes:
      "Since 2011, Hiring Our Heroes has helped hundreds of thousands find employment. NH veterans can take advantage of events in the New England region. Corporate Fellowship Program often leads to full-time jobs.",
  },
  {
    id: 70,
    name: "Helmets to Hardhats (H2H)",
    category: "Employment and Career Services",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "",
    website: "https://helmetstohardhats.org",
    email: "",
    services: [
      "Construction trades apprenticeship placement",
      "Connection to trade unions",
      "Paid on-the-job training",
      "GI Bill housing stipend eligibility",
    ],
    description:
      "A national program connecting veterans (including National Guard/Reserve) to careers in the construction trades. H2H helps translate military experience to apprenticeship placements with trade unions in carpentry, electrical, plumbing, HVAC, ironwork, etc.",
    notes:
      "No prior experience required. Facilitates entry into federally-approved apprenticeship training with paid on-the-job training. Many NH trade unions participate, including connections to apprenticeships with the International Brotherhood of Electrical Workers or the Carpenters Union in New England.",
  },
  {
    id: 71,
    name: "VA Veteran Readiness & Employment (VR&E) (Chapter 31)",
    category: "Employment and Career Services",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "Manchester VA Regional Office",
    phone: "(603) 624-4366 ext. 2650",
    website: "https://benefits.va.gov/vocrehab/",
    email: "",
    services: [
      "Comprehensive career and education services",
      "Education/training funding",
      "Career counseling and rehabilitation services",
      "Apprenticeships and on-the-job training",
    ],
    description:
      "The VA's VR&E program (formerly 'Vocational Rehab') offers comprehensive career and education services for veterans with service-connected disabilities who have employment barriers. VR&E can fund education/training and provide supportive rehabilitation services.",
    notes:
      "VR&E counselors work one-on-one with eligible veterans to craft personalized employment plans – it's essentially an individualized career assistance benefit. Apply through va.gov.",
  },

  // Veteran Service Organizations and Advocacy (Additional)
  {
    id: 72,
    name: "Iraq and Afghanistan Veterans of America (IAVA)",
    category: "Veteran Service Organizations and Advocacy",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "1-855-91-RAPID (855-917-2743)",
    website: "https://iava.org",
    email: "",
    services: [
      "Post-9/11 veterans advocacy",
      "Quick Reaction Force (QRF) 24/7 case management",
      "Policy advocacy on VA reform and burn pit exposure",
      "Community resources and support",
    ],
    description:
      "A leading post-9/11 veterans organization dedicated to advocacy and support for the newest generation of veterans. IAVA fights for policy changes and provides free membership with access to community resources.",
    notes:
      "Their Quick Reaction Force (QRF) offers 24/7 case management for veterans of any era, helping with everything from navigating VA care to emergency financial aid or mental health support.",
  },
  {
    id: 73,
    name: "Student Veterans of America (SVA)",
    category: "Veteran Service Organizations and Advocacy",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "",
    website: "https://studentveterans.org",
    email: "",
    services: [
      "Student veteran chapter support",
      "Leadership training and scholarships",
      "Internships and job connections",
      "Higher education advocacy",
    ],
    description:
      "A national coalition of student veteran chapters on college campuses. SVA advocates for student veterans' success in higher education and beyond, providing leadership training, scholarships, and connections to internships and jobs.",
    notes:
      "If a veteran is using the GI Bill or pursuing college in NH (e.g., UNH, Dartmouth, SNHU, etc.), their campus SVA chapter can offer peer support and resources for navigating college as a non-traditional student.",
  },
  {
    id: 74,
    name: "Team Red, White & Blue (Team RWB)",
    category: "Veteran Service Organizations and Advocacy",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "",
    website: "https://teamrwb.org",
    email: "",
    services: [
      "Physical and social activities for veterans",
      "Community building through fitness",
      "Running, biking, yoga, and ruck events",
      "Veteran wellness and camaraderie",
    ],
    description:
      "A nonprofit community that enriches veterans' lives by connecting them through physical and social activities. Team RWB has chapters and volunteer leaders around the country organizing regular workouts, events, and social gatherings.",
    notes:
      "Veterans (and civilian supporters) join via the Team RWB app to find local events in New England. If a veteran is feeling isolated or missing the teamwork of the military, Team RWB provides a positive community to be a part of.",
  },
  {
    id: 75,
    name: "Team Rubicon",
    category: "Veteran Service Organizations and Advocacy",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "",
    website: "https://teamrubiconusa.org",
    email: "northeast@teamrubiconusa.org",
    services: [
      "Disaster response volunteer opportunities",
      "Emergency relief missions",
      "Community service projects",
      "Purpose-driven service for veterans",
    ],
    description:
      "An international disaster response organization that recruits veterans as volunteers for emergency relief missions. It offers veterans the chance to continue serving by helping communities hit by floods, hurricanes, wildfires and other disasters.",
    notes:
      "New Hampshire falls under TR Region 1. Even when not deployed, local 'Greyshirts' (volunteers) engage in community service projects. This is a great outlet for veterans to use their skills in a fulfilling way, which can improve mental health and networking while aiding those in need.",
  },
  {
    id: 76,
    name: "Honor Flight New England",
    category: "Veteran Service Organizations and Advocacy",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "(603) 518-5368",
    website: "https://honorflightnewengland.org",
    email: "",
    services: [
      "Free flights to Washington, D.C. war memorials",
      "Complete memorial tour experience",
      "Priority for WWII, Korean War, terminally ill veterans",
      "Vietnam veteran participation",
    ],
    description:
      "A nonprofit that honors America's veterans by flying them to Washington, D.C. to visit their war memorials – at no cost to the veteran. Priority is given to WWII, Korean War, and terminally ill veterans, followed by Vietnam veterans.",
    notes:
      "Honor Flight provides the entire experience (flight, meals, tours, guardians) as a 'thank you' for veterans' service. For older veterans who may not have seen the memorials, this is a profound experience and is completely free due to generous donations and volunteers.",
  },
  {
    id: 77,
    name: "Blinded Veterans Association (BVA)",
    category: "Veteran Service Organizations and Advocacy",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "1-800-669-7079",
    website: "https://bva.org",
    email: "",
    services: [
      "Support for visually impaired veterans",
      "Blind rehabilitation services connection",
      "Technology assistance",
      "Benefits advocacy (Special Monthly Compensation)",
    ],
    description:
      "A congressionally chartered VSO that supports visually impaired veterans. BVA advocates for advancements in blind rehabilitation, connects members with VA Blind Rehab Services, and offers peer support.",
    notes:
      "The New England Regional Group of BVA includes New Hampshire. They assist blinded or low-vision veterans with access to technology, benefits, and training opportunities.",
  },
  {
    id: 78,
    name: "Service Women's Action Network (SWAN)",
    category: "Veteran Service Organizations and Advocacy",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "",
    website: "https://www.servicewomensactionnetwork.org/",
    email: "info@servicewomen.org",
    services: [
      "Female veteran advocacy",
      "Military sexual trauma assistance",
      "Policy reform advocacy",
      "Pro bono legal help",
    ],
    description:
      "A national advocacy organization for female veterans and service members. SWAN works to reform policies on issues like military sexual trauma, women's healthcare, and equal opportunity, and provides a resource portal for women veterans.",
    notes:
      "They also have a peer support program and can help women veterans connect with pro bono legal help (especially for MST or discrimination cases). SWAN ensures that the voices of women veterans are heard and that they receive equal access to benefits and respect.",
  },
  {
    id: 79,
    name: "Blue Star Families",
    category: "Veteran Service Organizations and Advocacy",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "",
    website: "https://bluestarfam.org",
    email: "",
    services: [
      "Military family support programs",
      "Community-building events",
      "Caregiver support",
      "Research-driven advocacy",
    ],
    description:
      "While aimed primarily at current military families, Blue Star Families has programs that can include veterans' families – especially Guard/Reserve families transitioning to veteran status. They offer community-building events, caregiver support, and advocacy.",
    notes:
      "In NH, Blue Star Families has a chapter that hosts events like family outings, job fairs, and appreciation events which veterans' families are welcome to join.",
  },
  {
    id: 80,
    name: "Travis Manion Foundation – Service Platoons",
    category: "Veteran Service Organizations and Advocacy",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "",
    website: "https://www.travismanion.org/TMC",
    email: "",
    services: [
      "Community service volunteer opportunities",
      "Service Platoons for veterans and families of the fallen",
      "Youth mentoring and leadership programs",
      "Community improvement projects",
    ],
    description:
      "Travis Manion Foundation carries forward The Mission Continues Service Platoons, connecting veterans, families of the fallen, and community volunteers through service and youth mentorship.",
    notes:
      "Travis Manion Foundation acquired The Mission Continues in 2025, and the former brand sunset in August 2026. Service Platoons continue within the TMF chapter structure; search the official site for current regional opportunities.",
  },

  // Legal Services (Additional)
  {
    id: 81,
    name: "Veterans Legal Justice (VLJ) – New Hampshire",
    category: "Legal Services",
    counties: ["All", "Strafford"],
    address: "35A Mill Pond Rd, Durham, NH 03824",
    phone: "(603) 397-0650",
    website: "https://vljnh.org",
    email: "info@vljnh.org",
    services: [
      "Pro bono legal services for NH veterans",
      "Housing and landlord-tenant assistance",
      "Family law and consumer debt help",
      "Discharge upgrades and VA benefit appeals",
    ],
    description:
      "A nonprofit initiative providing pro bono legal services to NH veterans, service members, and their families. VLJ helps with a wide range of civil legal issues, matching veterans with volunteer attorneys or legal clinics at no cost.",
    notes:
      "VLJ works closely with law schools and bar associations to ensure veterans get the legal help they need, recognizing that unresolved legal issues can be barriers to stability.",
  },
  {
    id: 82,
    name: "603 Legal Aid – Veterans Hotline (Hope for Heroes Project)",
    category: "Legal Services",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "(603) 224-3333",
    website: "https://603legalaid.org",
    email: "",
    services: [
      "Veterans-specific legal intake line",
      "Free legal advice for low-income veterans",
      "Eviction defense and benefit denials",
      "Pro bono program referrals",
    ],
    description:
      "New Hampshire's legal aid organization operates a veterans-specific intake line as part of their Hope for Heroes Project. Low-income veterans can get free legal advice or representation for civil issues.",
    notes:
      "If 603 Legal Aid cannot assist directly, they will refer the veteran to a pro bono program or the NH Bar Association's Pro Bono Referral Program which has a panel for veterans.",
  },
  {
    id: 83,
    name: "Veterans Consortium Pro Bono Program",
    category: "Legal Services",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "1-888-838-7727",
    website: "https://www.vetsprobono.org/apply/",
    email: "",
    services: [
      "Free attorneys for VA claims appeals",
      "Court of Appeals for Veterans Claims representation",
      "Discharge Upgrade Program",
      "Legal help for PTSD, MST, or TBI cases",
    ],
    description:
      "A national program that provides free attorneys for veterans appealing VA claims to the U.S. Court of Appeals for Veterans Claims (CAVC). If a veteran has been denied at the BVA level, the Veterans Consortium can assign a volunteer attorney at no charge.",
    notes:
      "They also have a Discharge Upgrade Program offering free legal help to veterans seeking to upgrade a less-than-honorable discharge. This is an excellent resource for veterans who feel their VA denial was unjust – the Consortium has a high success rate in wins or remands at the Court.",
  },
  {
    id: 84,
    name: "Stateside Legal",
    category: "Legal Services",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "",
    website: "https://www.statesidelegal.org",
    email: "",
    services: [
      "Online legal resource portal for veterans",
      "Free self-help guides and form letters",
      "Legal information on VA benefits and discharge upgrades",
      "Veterans Legal Help Navigator",
    ],
    description:
      "An online legal resource portal for veterans and military families. Stateside Legal offers free self-help guides, form letters, and information on a variety of legal topics including VA benefits, discharge upgrades, family law, and employment rights.",
    notes:
      "Available 24/7 online. Stateside Legal is a project of Pine Tree Legal Assistance of Maine, supported by the Legal Services Corporation and referenced by the VA as a go-to source for legal information.",
  },

  // Online Resources and Support Groups (Additional)
  {
    id: 85,
    name: "MakeTheConnection.net",
    category: "Online Resources and Support Groups",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "",
    website: "https://www.maketheconnection.net",
    email: "",
    services: [
      "Video testimonials from veterans",
      "Mental health recovery stories",
      "Anonymous self-check quiz",
      "Local support locator",
    ],
    description:
      "A VA-run online mental health resource featuring hundreds of video testimonials from veterans about their challenges and recovery. It covers topics like PTSD, substance use, transition stress, and family issues.",
    notes:
      "Users can filter stories by service era, discharge status, or gender to find relatable experiences. This is a great starting point for a veteran who might not be ready to seek help in person – hearing others' stories can encourage them that they're not alone.",
  },
  {
    id: 86,
    name: "RallyPoint",
    category: "Online Resources and Support Groups",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "",
    website: "https://rallypoint.com",
    email: "",
    services: [
      "Professional social network for military and veterans",
      "Forums for VA benefits and job hunting questions",
      "Mentorship function",
      "Daily discussions on veteran news",
    ],
    description:
      "A professional social network for the military and veterans (think LinkedIn meets Facebook for vets). RallyPoint has forums where veterans can ask questions about VA benefits, job hunting, PTSD resources, and get answers from other veterans and experts.",
    notes:
      "Free to join for verified service members and veterans. It also features a mentorship function and daily discussions on news affecting veterans.",
  },
  {
    id: 87,
    name: "PsychArmor",
    category: "Online Resources and Support Groups",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "",
    website: "https://psycharmor.org",
    email: "",
    services: [
      "Free educational courses for veterans",
      "Veteran cultural competency training",
      "Financial literacy for veterans",
      "Caregiver training programs",
    ],
    description:
      "An online library of free educational courses for veterans, caregivers, and anyone who works with veterans. Courses include Veteran 101 (cultural competency), navigating VA healthcare, financial literacy for vets, and caregiver training.",
    notes:
      "PsychArmor's mission is to educate and empower veterans and their support systems. Simply create a free account to access courses.",
  },
  {
    id: 88,
    name: "VA Mobile Apps",
    category: "Online Resources and Support Groups",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "",
    website: "https://mobile.va.gov",
    email: "",
    services: [
      "PTSD Coach - techniques to manage PTSD symptoms",
      "VetChange - helps veterans cut down on problem drinking",
      "PE Coach / CBT-i Coach - for therapy support",
      "Beyond MST - self-help app for military sexual trauma survivors",
    ],
    description:
      "A collection of helpful mobile apps from the VA and DoD for self-help and support. Apps include PTSD Coach (relaxation exercises and symptom tracker), VetChange (for drinking reduction), and Beyond MST (for MST survivors).",
    notes:
      "All apps are free and do not require a login or giving personal information. Available in the Apple and Google app stores.",
  },
  {
    id: 89,
    name: "NAMI Homefront (Online)",
    category: "Online Resources and Support Groups",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "",
    website: "https://www.nami.org/programs/nami-homefront/",
    email: "",
    services: [
      "Free online program for military families",
      "6-session workshop for family members",
      "Education about PTSD, TBI, and treatment options",
      "Support for families of veterans with mental health conditions",
    ],
    description:
      "The National Alliance on Mental Illness offers a free online program called NAMI Homefront, a 6-session workshop for family members of veterans/service members with mental health conditions. It helps families learn about PTSD, TBI, and treatment options.",
    notes:
      "It's the virtual adaptation of their in-person class, facilitated by trained instructors who are also family of veterans.",
  },
  {
    id: 9,
    name: "New Hampshire State Veterans Cemetery",
    category: "Government Agencies and Services",
    counties: ["All", "Merrimack"],
    address: "110 Daniel Webster Hwy, Boscawen, NH 03303",
    phone: "(603) 796-2026",
    website: "https://www.nhsvc.com/contact",
    email: "",
    services: [
      "Burial services for veterans",
      "Memorial services for eligible family members",
      "Military honors ceremonies",
      "Dignified final resting place",
    ],
    description:
      "State-operated veterans cemetery in Boscawen, NH offering burial and memorial services for veterans and eligible family members. Provides a dignified final resting place with military honors in a peaceful setting.",
    notes:
      "State-operated facility providing burial services with military honors.",
  },
  {
    id: 45,
    name: "VA Women Veterans Call Center",
    category: "Government Agencies and Services",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "1-855-VA-WOMEN (1-855-829-6636)",
    website: "https://www.womenshealth.va.gov/wvcc.asp",
    email: "",
    services: [
      "Women veterans health care navigation",
      "Maternity care information",
      "Women's health services guidance",
      "Connection to Women Veteran Program Managers",
    ],
    description:
      "Nationwide VA call center for women veterans, which helps female veterans navigate VA services and benefits. Staffed by women (many are veterans), providing information on health care and benefits.",
    notes:
      "Available M–F 8am–10pm ET, Sat 8am–6:30pm ET. Free and confidential support for any questions or concerns women veterans may have.",
  },
  {
    id: 46,
    name: "VA Caregiver Support Line",
    category: "Government Agencies and Services",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "1-855-260-3274",
    website: "https://caregiver.va.gov",
    email: "",
    services: [
      "Caregiver benefits navigation",
      "Respite services information",
      "Peer support for caregivers",
      "Counseling and education on VA programs",
    ],
    description:
      "Toll-free support line for veteran caregivers (family or friends providing care to veterans). Operated by the VA's Caregiver Support Program, offering help with navigating caregiver benefits and peer support.",
    notes:
      "Available M–F 8am–10pm ET, Sat 8am–5pm ET. Staff provide counseling, education, and referrals tailored to caregiver needs.",
  },
  {
    id: 47,
    name: "Employer Support of the Guard and Reserve (ESGR)",
    category: "Government Agencies and Services",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "1-800-336-4590",
    website: "https://esgr.mil",
    email: "",
    services: [
      "Employment mediation for Guard/Reserve members",
      "USERRA rights education",
      "Employer education programs",
      "Reemployment assistance",
    ],
    description:
      "A Department of Defense program that assists National Guard/Reserve members and their employers. ESGR mediates employment or reemployment issues for reserve-component service members and educates employers on USERRA rights.",
    notes:
      "While not a direct benefits provider, many Guard/Reserve veterans utilize ESGR for job protections and employment issues.",
  },

  // Mental Health and SUD (Additional)
  {
    id: 48,
    name: "Headstrong Project",
    category: "Mental Health and SUD",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "",
    website: "https://theheadstrongproject.org/",
    email: "",
    services: [
      "Cost-free mental health treatment",
      "Evidence-based trauma therapy",
      "PTSD and MST treatment",
      "Up to 30 sessions at no charge",
    ],
    description:
      "A national non-profit offering cost-free, confidential mental health treatment for post-9/11 veterans and families. Headstrong specializes in evidence-based trauma therapy with a network of clinicians across the U.S.",
    notes:
      "Eliminates barriers like paperwork and waits, aiming for quick access to care. Veterans can request care online and are matched with a clinician in their state.",
  },
  {
    id: 49,
    name: "Give An Hour",
    category: "Mental Health and SUD",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "(202) 297-4200",
    website: "https://giveanhour.org",
    email: "",
    services: [
      "Free counseling sessions",
      "Licensed mental health professionals",
      "One free therapy hour per week for up to a year",
      "Confidential counseling services",
    ],
    description:
      "A non-profit that connects veterans, service members, and their families with licensed mental health professionals volunteering free counseling. The program covers a range of issues including depression, anxiety, and relationship counseling.",
    notes:
      "Program has provided free mental health services to thousands of veterans since 2005. Participants can receive one free therapy hour per week for up to a year.",
  },
  {
    id: 51,
    name: "Stop Soldier Suicide",
    category: "Crisis Support",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "984-207-3260",
    website: "https://stopsoldiersuicide.org",
    email: "",
    services: [
      "Suicide prevention for veterans",
      "Intensive one-on-one case management",
      "Wellness plans and counseling",
      "Data-driven proactive outreach",
    ],
    description:
      "The only national non-profit focused solely on preventing veteran and service member suicide. Provides intensive case management, wellness plans, and counseling for veterans at risk, using data-driven proactive outreach.",
    notes:
      "All services are free and confidential, regardless of discharge status. Team works with callers over months to tackle crises, mental health needs, financial strain, or anything impacting well-being. Available to all veterans, not just post-9/11, and families can call on behalf of a veteran.",
  },
  {
    id: 52,
    name: "Objective Zero",
    category: "Crisis Support",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "",
    website: "https://objectivezero.org",
    email: "",
    services: [
      "24/7 peer support via mobile app",
      "Anonymous veteran community connection",
      "Crisis support via text, voice, or video",
      "Mental health ambassador support",
    ],
    description:
      "A peer support mobile app that anonymously connects veterans (or service members) in crisis to a nationwide community of veteran peers, mental health ambassadors, and licensed counselors. Available 24/7 via text, voice, or video.",
    notes:
      "Download 'Objective Zero' app (iOS/Android). This resource is particularly useful for younger, tech-savvy veterans seeking immediate peer support at any hour.",
  },
  {
    id: 53,
    name: "Tragedy Assistance Program for Survivors (TAPS)",
    category: "Crisis Support",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "800-959-8277",
    website: "https://www.taps.org/services",
    email: "",
    services: [
      "24/7 National Military Survivor Helpline",
      "Grief counseling for military families",
      "Survivor seminars and children's camps",
      "Peer mentor connections",
    ],
    description:
      "TAPS supports families grieving the loss of a service member or veteran. They offer crisis counseling, connections to peer mentors, grief counseling, survivor seminars, and support groups at no cost to surviving family members.",
    notes:
      "24/7 helpline available. This is a critical resource for families of veterans who died by suicide or other causes, offering a compassionate community of peers. Serves surviving spouses, parents, children, battle buddies – anyone affected by a military loss.",
  },

  // Housing and Homelessness Assistance (Additional)
  {
    id: 54,
    name: "Liberty House (Manchester, NH)",
    category: "Housing and Homelessness Assistance",
    counties: ["All", "Hillsborough"],
    address: "221 Orange Street, Manchester, NH 03104",
    phone: "(603) 669-0761",
    website: "https://libertyhousenh.org/contact/",
    email: "",
    services: [
      "Substance-free transitional housing",
      "Case management services",
      "Employment and housing assistance",
      "Food pantry and clothing closet",
      "Veterans helping veterans community",
    ],
    description:
      "A substance-free transitional housing program for homeless and struggling veterans in New Hampshire. Veterans can live for 90 days to 1 year while working toward independence in a 'Veterans helping Veterans' community environment.",
    notes:
      "Certified by the NH Coalition of Recovery Residences. Now a program of Catholic Charities NH, it is the only sobriety-focused transitional living facility for veterans in the state.",
  },
  {
    id: 55,
    name: "Friends of Veterans (FOV)",
    category: "Housing and Homelessness Assistance",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "28 Farmvu Dr, Suite 3, White River Junction, VT 05001",
    phone: "(802) 296-8368",
    website: "https://fovvtnh.org",
    email: "assistance@fovvtnh.org",
    services: [
      "Emergency financial assistance",
      "Rent and mortgage payment assistance",
      "Security deposits and utility bills",
      "Car repair assistance (when needed for work)",
      "Service dog veterinary bills",
    ],
    description:
      "A volunteer-run nonprofit serving Vermont and New Hampshire that provides emergency financial assistance to prevent veteran homelessness. The goal is to keep veterans and their families stably housed and avoid homelessness.",
    notes:
      "Friends of Veterans has provided over $500,000 in assistance to more than 800 veterans in NH and VT in the last five years.",
  },
  {
    id: 56,
    name: "NECHV Merrimack Valley (formerly VNEOC services)",
    category: "Housing and Homelessness Assistance",
    counties: ["Rockingham"],
    address: "Merrimack Valley; contact program for service location",
    phone: "(978) 305-9810",
    website: "https://nechv.org/get-help/merrimack-valley/",
    email: "christopher.nowak@nechv.org",
    services: [
      "Veteran housing programs",
      "Case management and peer support",
      "Behavioral health services",
      "Employment and training assistance",
      "Financial assistance and benefits navigation",
    ],
    description:
      "New England Center and Home for Veterans has assumed operations, management, and ownership of many former VNEOC facilities and its GPD Transition in Place program, expanding housing and supportive services in the Merrimack Valley.",
    notes:
      "New Hampshire eligibility and service-area coverage require confirmation with the Merrimack Valley team before referral. Contact Christopher Nowak using the listed phone or email for current programs, intake, and service locations.",
  },
  {
    id: 57,
    name: "Operation Homefront",
    category: "Housing and Homelessness Assistance",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "(210) 659-7756",
    website: "https://operationhomefront.org",
    email: "",
    services: [
      "Critical Financial Assistance grants",
      "Transitional Housing (Villages)",
      "Permanent Homes for Veterans program",
      "Emergency financial aid",
    ],
    description:
      "A national nonprofit that provides emergency financial aid and housing services to post-9/11 veterans and military families. Programs include critical financial assistance, transitional housing, and mortgage-free homes for veterans.",
    notes:
      "Assistance often fills gaps for veterans who might not qualify for VA homelessness programs, focusing on young families and those impacted by service.",
  },
  {
    id: 58,
    name: "Homes for Our Troops (HFOT)",
    category: "Housing and Homelessness Assistance",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "6 Main St, Taunton, MA 02780",
    phone: "1-866-787-6677",
    website: "https://www.hfotusa.org/",
    email: "",
    services: [
      "Specially adapted custom homes",
      "Mortgage-free homes for severely injured veterans",
      "ADA-compliant features and accessibility",
      "Pro-bono financial planning and homeownership education",
    ],
    description:
      "A national 501(c)(3) organization that builds and donates specially adapted custom homes for severely injured post-9/11 veterans. These mortgage-free homes are designed to accommodate disabilities and help injured veterans regain independence.",
    notes:
      "As of 2025, HFOT has built over 360 homes nationwide for amputees, those with paralysis, severe TBI, and other combat-related injuries.",
  },
  {
    id: 59,
    name: "Building Homes for Heroes",
    category: "Housing and Homelessness Assistance",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "4584 Austin Blvd, Island Park, NY 11558",
    phone: "(516) 684-9220",
    website: "https://buildinghomesforheroes.org",
    email: "",
    services: [
      "Mortgage-free homes for injured veterans",
      "Home renovations and accessibility modifications",
      "Financial planning and budget coaching",
      "Family support services",
    ],
    description:
      "A major nonprofit that gifts mortgage-free homes to veterans who suffered severe injuries in the line of duty (post-9/11). They either build new homes or renovate existing homes to meet the veteran's needs, then provide the home at no cost.",
    notes:
      "Also offers financial planning, household budget coaching, and family support to ensure long-term success for the veteran homeowner.",
  },
  {
    id: 60,
    name: "Purple Heart Homes",
    category: "Housing and Homelessness Assistance",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "755 Washington Ave, Statesville, NC 28677",
    phone: "(704) 838-4044",
    website: "https://www.purplehearthomesusa.org",
    email: "",
    services: [
      "Safe Home renovations for disabled/aging veterans",
      "Veterans Next Door affordable housing",
      "Tiny Homes programs",
      "Accessibility modifications (ramps, grab bars, bathrooms)",
    ],
    description:
      "A nonprofit that provides housing solutions for service-connected disabled and aging veterans. Services range from Safe Home renovations to offering affordable housing through various programs.",
    notes:
      "Partners with local communities and volunteers to ensure veterans can live safely and with dignity in their homes.",
  },

  // Benefits, Claims, and Financial Assistance (Additional)
  {
    id: 61,
    name: "American Legion – Service Officers & Temporary Financial Assistance",
    category: "Benefits, Claims, and Financial Assistance",
    counties: ["All", "Hillsborough"],
    address: "275 Chestnut St, Room 519, Manchester, NH 03101",
    phone: "(603) 222-5786",
    website: "https://legionnh.org/department-service-officer",
    email: "",
    services: [
      "Free VA claims assistance through accredited Service Officers",
      "Temporary Financial Assistance (TFA) program",
      "Emergency funds for veterans with minor children",
      "Assistance with shelter, utilities, food, and medical care",
    ],
    description:
      "The American Legion provides direct help with VA claims through accredited Service Officers at no cost, and a national Temporary Financial Assistance program. TFA can provide emergency funds to eligible veterans with minor children for necessities.",
    notes:
      "Accredited American Legion service officers provide free assistance with compensation, pension, appeals, vocational rehabilitation, home-loan guarantees, records, awards, and discharge-upgrade questions. Temporary Financial Assistance inquiries may also begin through a local Legion post.",
  },
  {
    id: 62,
    name: "Military Order of the Purple Heart (MOPH) – National Service Officers",
    category: "Benefits, Claims, and Financial Assistance",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "JFK Federal Building, Boston, MA (Regional NSO Office)",
    phone: "(617) 303-5696",
    website: "https://purpleheart.org",
    email: "",
    services: [
      "Free VA claims assistance for all veterans",
      "Appeals and discharge upgrades",
      "Military records assistance",
      "Scholarship programs",
    ],
    description:
      "A Congressionally-chartered VSO that offers free VA claims assistance to all veterans (not just Purple Heart recipients) through their National Service Officer program. They help with filing VA disability claims, appeals, and discharge upgrades.",
    notes:
      "For NH, the regional NSO office is in Boston. Also has a scholarship program for veterans and their families.",
  },
  {
    id: 63,
    name: "USA Cares",
    category: "Benefits, Claims, and Financial Assistance",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "(800) 773-0387",
    website: "https://usacares.org",
    email: "",
    services: [
      "Emergency financial assistance grants",
      "Career transition job training scholarships",
      "Mortgage/rent, utility, and vehicle payment assistance",
      "Post-service skills training programs",
    ],
    description:
      "A Kentucky-based national nonprofit providing financial assistance and post-service skills training to post-9/11 veterans, active service members, and their families. Their Emergency Assistance program issues grants (not loans) to cover essentials during financial crises.",
    notes:
      "Can often assist when veterans do not qualify for military relief society aid or need rapid help without adding to debt. Also offers job training scholarships for veterans seeking employment in industries like IT, healthcare, and trade skills.",
  },
  {
    id: 64,
    name: "Operation First Response (OFR)",
    category: [
      "Benefits, Claims, and Financial Assistance",
      "Employment and Career Services",
      "Mental Health and SUD",
    ],
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "(888) 289-0280",
    website: "https://www.operationfirstresponse.org/assistance-request/",
    email: "info@operationfirstresponse.org",
    services: [
      "Emergency assistance for eligible active-duty service members and Gold Star families",
      "Project Specialized Training for qualifying veterans",
      "Last Mission Project treatment-related assistance for qualifying combat veterans",
    ],
    description: "Nationwide nonprofit with emergency aid for currently serving military members and eligible survivors. Veterans may qualify for IT certification training or case-by-case assistance during approved inpatient PTSD, substance use, or trauma treatment.",
    notes: "General emergency financial assistance no longer serves veterans solely on veteran status. There is no public application window; email the program to discuss eligibility. Assistance depends on individual review and available funding.",
  },
  {
    id: 65,
    name: "Coast Guard Mutual Assistance (CGMA)",
    category: "Benefits, Claims, and Financial Assistance",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "(703) 875-0404",
    website: "https://mycgma.org/",
    email: "",
    services: [
      "Interest-free loans for Coast Guard veterans",
      "Emergency grants for financial crises",
      "Home repair and medical bill assistance",
      "Educational assistance programs",
    ],
    description:
      "CGMA offers interest-free loans and grants for financial emergencies to Coast Guard members, retirees, and their immediate families. If a Coast Guard veteran in NH faces an emergency, CGMA might provide relief funds or referrals.",
    notes:
      "Important resource specifically for Coast Guard veterans. Loans generally arranged through CG bases or via the American Red Cross after hours. Each military branch has a relief society with similar services.",
  },

  // Employment and Career Services (Additional)
  {
    id: 66,
    name: "Hire Heroes USA",
    category: "Employment and Career Services",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "(844) 634-1520",
    website: "https://www.hireheroesusa.org/contact-us/",
    email: "",
    services: [
      "Free employment services for veterans and military spouses",
      "One-on-one career coaching",
      "Resume and LinkedIn profile writing",
      "Interview preparation and job sourcing",
      "Virtual career fairs and job board",
    ],
    description:
      "A leading national nonprofit providing free employment services for veterans and military spouses. Veterans are paired with a transition specialist and/or professional volunteers to help translate their military experience into civilian opportunities.",
    notes:
      "As of 2025, Hire Heroes USA has helped over 65,000 veterans/spouses find jobs, boasting a high success rate in getting vets hired in meaningful careers. Sign up as a client on the website.",
  },
  {
    id: 67,
    name: "American Corporate Partners (ACP)",
    category: "Employment and Career Services",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "(212) 752-0700",
    website: "https://www.acp-usa.org",
    email: "info@acp-usa.org",
    services: [
      "Free nationwide mentorship program",
      "Year-long mentorship for post-9/11 veterans",
      "Career guidance and networking",
      "Professional development with corporate mentors",
    ],
    description:
      "A nonprofit that runs a free nationwide mentorship program for post-9/11 veterans (and active duty spouses). ACP connects veterans with experienced corporate mentors for a year-long mentorship, focused on career guidance and networking.",
    notes:
      "Mentors come from dozens of industries and Fortune 500 companies. More than 25,000 veterans have completed ACP mentorships, and the service is recommended by the DoD Transition Assistance Program. Apply online as a Protégé.",
  },
  {
    id: 68,
    name: "Veterans Guide — VA Disability Back Pay & Benefits Resources",
    category: "Benefits, Claims, and Financial Assistance",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "",
    website: "https://veteransguide.org/",
    email: "outreach@veteransguide.org",
    services: [
      "VA Disability Back Pay Calculator (estimate back pay by rating & effective date)",
      "Guides on VA disability ratings and benefits (incl. 100% benefits)",
      "Education on GI Bill, financial assistance, and veteran programs",
      "Advocacy information and veteran-focused resource hub",
    ],
    description:
      "Online advocacy center providing veteran-focused benefit education and tools—highlighted by a VA Disability Back Pay Calculator—to help veterans and families understand potential compensation and available programs.",
    notes:
      "Calculator and resources are educational tools (not official VA determinations). Helpful links: Back Pay Calculator (veteransguide.org/back-pay-calculator) and 100% Benefits overview (veteransguide.org/va-ratings/100-percent/).",
  },
  {
    id: 93,
    name: "Carroll County Veterans Coalition",
    category: "Crisis Support",
    counties: ["Carroll"],
    address: "1230 NH-16, Ossipee, NH 03864",
    phone: "(603) 301-1252 ext. 305",
    website: "https://www.carrollcountyveteranscoalition.org/",
    email: "jennifer.thomas@graniteuw.org",
    services: [
      "Suicide prevention for veterans",
      "Community outreach and support groups",
      "Community resources and support",
      "Toolkits, education, and community training",
    ],
    description:
      "County-level veterans coalition focused on reducing social isolation and strengthening mental health support for Veterans in Carroll County, including regular meetings and local resource coordination.",
    notes:
      "Primary sources: https://www.carrollcountyveteranscoalition.org/veterans-coalitions and https://www.carrollcountyveteranscoalition.org/contact (checked 2026-03-14).",
  },
  {
    id: 94,
    name: "Capital Area Veterans Coalition",
    category: "Crisis Support",
    counties: [
      "Merrimack",
    ],
    address: "125 Airport Rd, Suite 3, Concord, NH 03301 (host office)",
    phone: "",
    website: "https://capitalareaphn.org/capital-area-veterans-coalition/",
    email: "capitalareavetsnh@gmail.com",
    services: [
      "Suicide prevention for veterans",
      "Community outreach and support groups",
      "Community resources and support",
      "Toolkits, education, and community training",
    ],
    description:
      "Regional veterans coalition focused on reducing Veteran suicide through community education, grassroots action, and connection to resources in the Capital Region.",
    notes: "The coalition meets monthly and serves the Capital Area in Merrimack County. Email the coalition to confirm the next meeting location and time.",
  },
  {
    id: 95,
    name: "Central Region Veterans Coalition",
    category: "Crisis Support",
    counties: [
      "Grafton",
    ],
    address: "",
    phone: "",
    website: "https://www.facebook.com/profile.php?id=61559737680588",
    email: "jennifer.hunter@graniteuw.org",
    services: [
      "Suicide prevention for veterans",
      "Community outreach and support groups",
      "Community resources and support",
      "Toolkits, education, and community training",
    ],
    description:
      "Veterans suicide-prevention coalition hosted by Whole Family Resource Center in Plymouth, NH, focused on community coordination and referrals.",
    notes:
      "Primary source: https://www.carrollcountyveteranscoalition.org/veterans-coalitions (checked 2026-03-14). Note: official website appears to be Facebook-only.",
  },
  {
    id: 96,
    name: "Greater Manchester Veterans Coalition",
    category: "Crisis Support",
    counties: [
      "Hillsborough",
    ],
    address: "",
    phone: "",
    website: "https://brand.page/gmvc",
    email: "skilbreth@forgehealth.com",
    services: [
      "Suicide prevention for veterans",
      "Community outreach and support groups",
      "Community resources and support",
      "Toolkits, education, and community training",
    ],
    description:
      "Veterans coalition dedicated to reducing suicide risk in the Greater Manchester area by improving education, resource connection, and community-based referrals; hosted by Forge VFR and Easterseals.",
    notes:
      "Primary source: https://www.carrollcountyveteranscoalition.org/veterans-coalitions (checked 2026-03-14). Notes: additional email listed: shiggs@eastersealsnh.org.",
  },
  {
    id: 97,
    name: "Granite Hope Veterans Coalition",
    category: "Crisis Support",
    counties: ["Sullivan"],
    address: "",
    phone: "",
    website: "https://www.wcbh.org/granite-hope-veterans-coalition/",
    email: "Vetservices@wcbh.org",
    services: [
      "Suicide prevention for veterans",
      "Community outreach and support groups",
      "Community resources and support",
      "Toolkits, education, and community training",
    ],
    description:
      "Sullivan County-focused coalition hosted by West Central Behavioral Health to prevent Veteran suicide through training, awareness, resource connection, and reducing social isolation (meetings via Zoom).",
    notes:
      "Primary sources: https://www.carrollcountyveteranscoalition.org/veterans-coalitions and https://www.wcbh.org/granite-hope-veterans-coalition/ (checked 2026-03-14). Notes: additional email listed: wmetcalfe@wcbh.org.",
  },
  {
    id: 98,
    name: "Lakes Region Veterans Coalition",
    category: "Crisis Support",
    counties: [
      "Belknap",
    ],
    address: "",
    phone: "",
    website: "https://lrvcnh.org/",
    email: "info@lrvcnh.org",
    services: [
      "Suicide prevention for veterans",
      "Community outreach and support groups",
      "Community resources and support",
      "Toolkits, education, and community training",
    ],
    description:
      "Lakes Region coalition implementing Veteran-focused suicide prevention work through community leadership and local coordination.",
    notes:
      "Primary source: https://www.carrollcountyveteranscoalition.org/veterans-coalitions (checked 2026-03-14).",
  },
  {
    id: 100,
    name: "Stronger Together Veterans Coalition of NH",
    category: "Crisis Support",
    counties: [
      "Hillsborough",
    ],
    address: "180 Elm St. Ste. E, Milford, NH 03055",
    phone: "(603) 554-8142",
    website: "https://www.arcnh.org/stvc",
    email: "gsomers@arcnh.org",
    services: [
      "Suicide prevention for veterans",
      "Community outreach and support groups",
      "Community resources and support",
      "Toolkits, education, and community training",
    ],
    description:
      "Greater Nashua-area coalition convening Veterans, clinicians, recovery support workers, and community members to prevent Veteran suicide through coordination, education, and connection to care.",
    notes:
      "Primary source: https://www.carrollcountyveteranscoalition.org/veterans-coalitions (checked 2026-03-14).",
  },
  {
    id: 101,
    name: "Women Veteran Coalition of NH",
    category: "Crisis Support",
    counties: ["All"],
    address: "1750 Elm Street, Suite 103, Manchester, NH 03104",
    phone: "(603) 865-1706",
    website:
      "https://www.linkedin.com/company/women-veteran-coalition-of-new-hampshire/",
    email: "sbice@forgehealth.com",
    services: [
      "Suicide prevention for veterans",
      "Community outreach and support groups",
      "Connection to Women Veteran Program Managers",
      "Toolkits, education, and community training",
    ],
    description:
      "Statewide coalition focused on suicide prevention among women Veterans in New Hampshire, including policy and training subcommittees; based out of Manchester at Forge VFR.",
    notes:
      "Primary source: https://www.carrollcountyveteranscoalition.org/veterans-coalitions (checked 2026-03-14). Note: listed website is LinkedIn (social); confirm if additional official site exists.",
  },
  {
    id: 102,
    name: "RUCK-UP Inc.",
    category: "Mental Health and SUD",
    counties: ["All", "Cheshire"],
    address: "105V Maple Ave, Keene, NH 03431",
    phone: "(603) 903-1255",
    website: "https://www.ruck-up.org/",
    email: "ruckup@earthlink.net",
    services: [
      "Mental health & substance use treatment",
      "Benefits counseling",
      "Emergency financial assistance grants",
      "Peer support networks",
      "12-step program support",
    ],
    description:
      "Veteran-focused outpost in Keene providing peer/community support, counseling and recovery programming (including PTSD/substance-use supports), and assistance-grant pathways for Veterans in crisis.",
    notes:
      "Primary sources: https://www.ruck-up.org/ and https://www.ruck-up.org/outreach (checked 2026-03-14).",
  },
  {
    id: 103,
    name: "Forge VFR",
    category: "Mental Health and SUD",
    counties: ["All"],
    address: "115 Airport Road, Concord, NH 03301",
    phone: "(888) 831-1800",
    website: "https://forgehealth.com/vfr/",
    email: "info@forgehealth.com",
    services: [
      "Mental health & substance use treatment",
      "Outpatient SUD treatment and counseling",
      "Medication-assisted treatment (as clinically indicated)",
      "Telehealth services available",
      "Licensed mental health professionals",
    ],
    description:
      "Outpatient behavioral health and substance-use treatment program oriented to Veterans, first responders, and their families, with statewide New Hampshire access and a Concord location.",
    notes:
      "Primary source: https://forgehealth.com/locations/new-hampshire/ (contact/location and statewide wording; checked 2026-03-14); program overview: https://forgehealth.com/vfr/ (checked 2026-03-14).",
  },
  {
    id: 104,
    name: "Operation Delta Dog",
    category: "Mental Health and SUD",
    counties: ["All"],
    address: "12 Fitzgerald Rd, Suite 1, Hollis, NH 03049",
    phone: "(603) 854-4979",
    website: "https://operationdeltadog.org/",
    email: "info@operationdeltadog.org",
    services: [
      "Therapeutic activities",
      "Mental health care for post-9/11 veterans",
      "Community resources and support",
      "Service dog veterinary bills",
    ],
    description:
      "Nonprofit that supports Veterans by pairing them with trained service dogs to help address challenges such as PTSD and related mental health needs, with support and resources for Veterans and families.",
    notes:
      "Primary source: https://operationdeltadog.org/contact-us/ (checked 2026-03-14).",
  },
  {
    id: 105,
    name: "Camp Resilience",
    category: "Mental Health and SUD",
    counties: ["All"],
    address: "P.O. Box 7384, Gilford, NH 03247-7384",
    phone: "(978) 219-4003",
    website: "https://www.camp-resilience.org/",
    email: "info@camp-resilience.org",
    services: [
      "Retreat programs for wounded veterans",
      "Outdoor recreation programs",
      "Peer support networks",
      "Therapeutic activities",
      "Wellness plans and counseling",
    ],
    description:
      "Provides free 3\u20134 day retreats for service members, Veterans, first responders, and loved ones, combining peer-to-peer counseling, life skills workshops, and outdoor experiential learning focused on resilience and wellness.",
    notes:
      "Primary source: https://www.camp-resilience.org/ (contact details in footer; checked 2026-03-14).",
  },
  {
    id: 106,
    name: "Easterseals NH Military & Veterans Campus",
    category: "Housing and Homelessness Assistance",
    counties: ["All"],
    address: "27 Holy Cross Road, Franklin, NH 03235",
    phone: "(888) 285-9248",
    website: "https://militaryveteranscampusnh.org/",
    email: "",
    services: [
      "Affordable permanent housing",
      "Case management and housing navigation",
      "Permanent supportive housing",
      "Assistance with benefits, housing, and mental health resources",
    ],
    description:
      "Easterseals NH campus in Franklin that combines Veteran-focused housing and supportive services in one place, connecting residents to care coordination and partner resources.",
    notes:
      "Primary sources: https://militaryveteranscampusnh.org/contact/ and https://eastersealsnh.org/programs/military-veterans-campus/ (checked 2026-03-14). Note: site email address was protected/obfuscated at time of check; public email not retrievable, contact form available.",
  },
  {
    id: 107,
    name: "Roof-A-Vet",
    category: "Housing and Homelessness Assistance",
    counties: ["All"],
    address: "P.O. Box 492, Dover, NH 03821",
    phone: "",
    website: "https://www.roofavet.org/",
    email: "contact-us@roofavet.org",
    services: [
      "Home repair and medical bill assistance",
      "Community resources and support",
    ],
    description:
      "Provides roof replacement assistance for eligible Veterans at little or no cost; program messaging references the New Hampshire Seacoast but also notes availability for Veterans residing in New Hampshire.",
    notes:
      "Primary source: https://www.roofavet.org/ (checked 2026-03-14). Note: site does not list a phone number; contact is via email/forms.",
  },
  {
    id: 108,
    name: "Fisher House Foundation",
    category: "Housing and Homelessness Assistance",
    counties: ["All"],
    address: "12300 Twinbrook Pkwy, Suite 410, Rockville, MD 20852",
    phone: "(888) 294-8560",
    website: "https://fisherhouse.org/about/contact-us/",
    email: "info@fisherhouse.org",
    services: [
      "Emergency and transitional housing",
      "Housing program information",
      "Community resources and support",
    ],
    description:
      "Operates the Fisher House and related programs that help military and Veteran families with lodging and support when a loved one is receiving medical care.",
    notes:
      "Primary source: https://fisherhouse.org/about/contact-us/ (checked 2026-03-14). Notes: additional phone listed on page: (301) 294-8560.",
  },
  {
    id: 110,
    name: "Onward to Opportunity",
    category: "Employment and Career Services",
    counties: ["All"],
    address: "101 Waverly Ave, Syracuse, NY 13244",
    phone: "(315) 443-6898",
    website: "https://ivmf.syracuse.edu/programs/career-training/about-o2o/",
    email: "IVMFEducation@syr.edu",
    services: [
      "Comprehensive career and education services",
      "Career guidance",
      "Job placement services",
      "Career transition job training scholarships",
    ],
    description:
      "Career training program that provides free industry-focused training and job readiness support for Veterans, service members, and eligible military spouses, including remote options.",
    notes:
      "Primary sources: https://ivmf.syracuse.edu/programs/career-training/about-o2o/ (program overview; checked 2026-03-14); https://ivmf.syracuse.edu/wp-content/uploads/2022/03/O2O-GENERAL-one-pager-QR-CODEDIGITAL_3.14.22.pdf (enrollment email/phone; checked 2026-03-14).",
  },
  {
    id: 111,
    name: "FourBlock",
    category: "Employment and Career Services",
    counties: ["All"],
    address:
      "c/o Otterbourg P.C., 230 Park Avenue, 29th Floor, New York, NY 10169 (ATTN: FourBlock Foundation)",
    phone: "",
    website: "https://www.fourblock.org/",
    email: "",
    services: [
      "Career guidance and networking",
      "Professional development with corporate mentors",
      "Job coaching",
      "Interview preparation and job sourcing",
    ],
    description:
      "Veteran career development nonprofit offering programs that help service members and Veterans translate military experience into civilian careers through training and employer connections.",
    notes:
      "Primary source: https://fourblock.org/contact/ (checked 2026-03-14). Note: no public phone/email listed; contact via web form.",
  },
  {
    id: 112,
    name: "Warrior-Scholar Project",
    category: "Employment and Career Services",
    counties: ["All"],
    address:
      "201 N Union St, Suite 110-Box 19960, Alexandria, VA 22314",
    phone: "(202) 796-8777",
    website: "https://www.warrior-scholar.org/",
    email: "",
    services: [
      "Free educational courses for veterans",
      "Educational resources",
      "Comprehensive career and education services",
      "Career guidance",
    ],
    description:
      "Provides intensive academic and mentorship \u2018boot camp\u2019 programs that help Veterans succeed in higher education and transition into civilian careers.",
    notes:
      "Primary source: https://www.warrior-scholar.org/contact-us (checked 2026-03-14). Note: email not publicly listed; contact via web form.",
  },
  {
    id: 113,
    name: "National Veterans Legal Services Program",
    category: "Legal Services",
    counties: ["All"],
    address: "1100 Wilson Blvd, Suite 900, Arlington, VA 22209",
    phone: "(202) 265-8305",
    website: "https://nvlsp.org/",
    email: "info@nvlsp.org",
    services: [
      "Free legal services for veterans",
      "Pro bono legal help",
      "Online legal resource portal for veterans",
      "Legal information on VA benefits and discharge upgrades",
    ],
    description:
      "National nonprofit providing legal services, litigation, and resources to help Veterans obtain benefits, including issues like discharge upgrades and VA benefits eligibility.",
    notes:
      "Primary source: https://nvlsp.org/contact-us/ (checked 2026-03-14).",
  },
  {
    id: 114,
    name: "USO New England",
    category: "Veteran Service Organizations and Advocacy",
    counties: ["All"],
    address:
      "1 Harborside Dr, Terminal C (Lower Level), Boston, MA 02128 (USO Center location)",
    phone: "(617) 720-4949",
    website: "https://newengland.uso.org/",
    email: "newenglanduso@uso.org",
    services: [
      "Community programs",
      "Community-building events",
      "Veteran wellness and camaraderie",
      "Community resources and support",
    ],
    description:
      "Provides morale, welfare, and support programs for service members and military families across New England, including support at travel and deployment/transition points.",
    notes:
      "Primary source: https://newengland.uso.org/ (area contact info; checked 2026-03-14). Note: site lists multiple USO center locations; address provided is one official center location.",
  },
  {
    id: 115,
    name: "Gary Sinise Foundation",
    category: "Benefits, Claims, and Financial Assistance",
    counties: ["All"],
    address: "PO Box 40726, Nashville, TN 37204",
    phone: "(615) 575-3500",
    website: "https://www.garysinisefoundation.org/",
    email: "",
    services: [
      "Financial aid for wounded veterans and families",
      "Emergency financial aid",
      "Educational resources",
      "Community programs",
    ],
    description:
      "National foundation supporting service members, Veterans, first responders, and families through programs that can include financial and material support, community initiatives, and targeted assistance for those impacted by service.",
    notes:
      "Primary source: https://garysinisefoundation.org/contact/ (checked 2026-03-14). Note: site uses web forms for most inquiries; public email not listed.",
  },
  {
    id: 116,
    name: "Soldiers' Angels",
    category: "Veteran Service Organizations and Advocacy",
    counties: ["All"],
    address: "1355 Central Pkwy S, #700, San Antonio, TX 78232",
    phone: "(210) 629-0020",
    website: "https://soldiersangels.org/",
    email: "",
    services: [
      "Food pantry and clothing closet",
      "Community service volunteer opportunities",
      "Community outreach",
      "Community resources and support",
    ],
    description:
      "National volunteer-led nonprofit providing a range of support to service members and Veterans, including resource and basic-needs support programs and community engagement.",
    notes:
      "Primary source: https://soldiersangels.org/contact-us/ (checked 2026-03-14). Note: public email not listed; contact via web form.",
  },
  {
    id: 117,
    name: "Semper Fi & America\u2019s Fund",
    category: "Benefits, Claims, and Financial Assistance",
    counties: ["All"],
    address:
      "825 College Blvd, Suite 102 PMB 609, Oceanside, CA 92057",
    phone: "(760) 725-3680",
    website: "https://thefund.org/",
    email: "info@TheFund.org",
    services: [
      "Intensive one-on-one case management",
      "Emergency financial assistance",
      "Critical Financial Assistance grants",
      "Wellness plans and counseling",
    ],
    description:
      "Provides direct support, case management, and financial assistance to critically injured, ill, and wounded service members, Veterans, and their families.",
    notes:
      "Primary source: https://thefund.org/contact-us/ (checked 2026-03-14). Notes: page also lists business operations address in Quantico, VA.",
  },
  {
    id: 118,
    name: "Operation Care for Troops",
    category: "Veteran Service Organizations and Advocacy",
    counties: ["All"],
    address: "P.O. Box 1604, Nashua, NH 03061-1604",
    phone: "(603) 493-3512",
    website: "https://www.octnh.org/",
    email: "",
    services: [
      "Community service projects",
      "Community outreach",
      "Community service volunteer opportunities",
      "Community programs",
    ],
    description:
      "New Hampshire-based volunteer organization that sends care packages to deployed service members and provides community support projects such as holiday stockings for families in transition and Veterans in need.",
    notes:
      "Primary source: https://www.octnh.org/contact-us/ (checked 2026-03-14). Note: contact form requires JavaScript; email not publicly listed.",
  },
  {
    id: 119,
    name: "Swim With A Mission",
    category: "Veteran Service Organizations and Advocacy",
    counties: ["All"],
    address: "1 Hardy Road #127, Bedford, NH 03110",
    phone: "",
    website: "https://www.swam.org/",
    email: "info@swam.org",
    services: [
      "Community-building events",
      "Community programs",
      "Community resources and support",
      "Comprehensive resource directory",
    ],
    description:
      "New Hampshire nonprofit that raises funds and awareness to support Veteran service and support organizations, and provides curated resource information for Veterans and families.",
    notes:
      "Primary source: https://www.swam.org/ (footer contact; checked 2026-03-14). Note: no phone listed on site.",
  },
  {
    id: 120,
    name: "Veterans Resource Alliance of NH",
    category: "Veteran Service Organizations and Advocacy",
    counties: ["All"],
    address: "11 Fox Run Road, Raymond, NH 03077",
    phone: "(603) 856-5890",
    website:
      "https://volunteernh.galaxydigital.com/agency/detail/?agency_id=178144",
    email: "Info@vranh.org",
    services: [
      "Community-building events",
      "Community resources and support",
      "Resource navigation and referrals",
      "Community outreach",
    ],
    description:
      "Nonprofit network working to connect Veterans and families with resources and strengthen coordination among veteran-serving organizations, including large-scale resourcing events (e.g., VetFest).",
    notes:
      "Primary sources: https://volunteernh.galaxydigital.com/agency/detail/?agency_id=178144 and https://operationdeltadog.org/organizer/veterans-resource-alliance-of-nh/ (phone/email corroboration; checked 2026-03-14). Note: https://vranh.org/ returned an error/unreachable during verification attempt.",
  },
  {
    id: 121,
    name: "New Hampshire Veterans Association",
    category: "Veteran Service Organizations and Advocacy",
    counties: ["All"],
    address: "208 Lakeside Ave, Laconia, NH 03246",
    phone: "(603) 366-4470",
    website: "https://nhva.site/",
    email: "nhvaorg@gmail.com",
    services: [
      "Veteran wellness and camaraderie",
      "Community programs",
      "Community-building events",
      "Community resources and support",
    ],
    description:
      "Membership-based organization in Laconia that fosters camaraderie among Veterans and preserves the historic Weirs encampment property while offering a summer retreat setting for NH Veterans and families.",
    notes:
      "Primary source: https://nhva.site/ (checked 2026-03-14). Notes: site also lists PO Box 5591, Weirs Beach, Laconia, NH 03247.",
  },
  {
    id: 122,
    name: "New England Healing Sports Association",
    category: "Veteran Service Organizations and Advocacy",
    counties: ["All"],
    address: "PO Box 2135, 180 Mount Sunapee Rd, Newbury, NH 03255",
    phone: "(603) 763-9158",
    website: "https://nehsa.org/",
    email: "info@nehsa.org",
    services: [
      "Adaptive sports programs",
      "Adaptive programs",
      "Outdoor recreation programs",
      "Therapeutic activities",
    ],
    description:
      "Provides adaptive sports programs for Veterans and others with disabilities, including seasonal adaptive programming in New England with a New Hampshire base of operations.",
    notes:
      "Primary source: https://nehsa.org/ (contact info on page; checked 2026-03-14).",
  },
  {
    id: 123,
    name: "Back In The Saddle Equine Therapy Center",
    category: "Mental Health and SUD",
    counties: ["All", "Merrimack"],
    address: "223 Pumpkin Hill Rd, Warner, NH 03278",
    phone: "(603) 667-9015",
    website: "",
    email: "info@bitsetc.org",
    services: [
      "Therapeutic activities",
      "Wellness plans and counseling",
      "Community programs",
      "Peer support networks",
    ],
    description:
      "Equine-assisted programming and therapeutic services in Warner, NH, including cost-free programs for Veterans and first responders (RideUP/StepUP) alongside broader therapeutic riding and learning services.",
    notes:
      "RideUP is an eight-week equine program offered without cost to military veterans and first responders through donor support. Contact the program for scheduling and availability. The official domain currently serves a hosting-account suspension page; recheck for a restored program-specific URL.",
  },
  {
    id: 124,
    name: "Touchstone Farm",
    category: "Mental Health and SUD",
    counties: ["All", "Hillsborough"],
    address: "233 Old Temple Road, Lyndeborough, NH 03082",
    phone: "(603) 654-6308",
    website: "https://www.touchstone-farm.org/veterans/",
    email: "info@touchstone-farm.org",
    services: [
      "Therapeutic activities",
      "Community programs",
      "Peer support networks",
      "Veteran wellness and camaraderie",
    ],
    description:
      "Therapeutic riding/driving and equine-assisted services in Lyndeborough, including programming tailored for Veterans and families centered on resilience, empowerment, and connection.",
    notes:
      "Primary sources: https://www.touchstone-farm.org/contact/ and https://www.touchstone-farm.org/veterans/ (checked 2026-03-14).",
  },
  {
    id: 125,
    name: "Project Healing Waters Fly Fishing",
    category: "Mental Health and SUD",
    counties: ["All"],
    address: "1910 Marina Drive, Windsor, CO 80550",
    phone: "(866) 251-7252",
    website: "https://projecthealingwaters.org/",
    email: "",
    services: [
      "Therapeutic activities",
      "Outdoor recreation programs",
      "Peer support networks",
      "Community programs",
    ],
    description:
      "National nonprofit dedicated to the physical and emotional rehabilitation of disabled active military service personnel and Veterans through fly fishing and associated activities, offered at no cost.",
    notes:
      "Primary source: https://projecthealingwaters.org/contact/ (checked 2026-03-15). Note: no public email listed; contact via web form. Phone hours: M-F 9am-5pm ET.",
  },
  {
    id: 126,
    name: "Warriors Heart",
    category: "Mental Health and SUD",
    counties: ["All"],
    address: "756 Purple Sage Rd, Bandera, TX 78003",
    phone: "(844) 448-2567",
    website: "https://www.warriorsheart.com/",
    email: "",
    services: [
      "Mental health & substance use treatment",
      "Residential PTSD treatment",
      "Substance use disorder treatment",
      "Co-occurring disorder treatment",
    ],
    description:
      "Private residential treatment center exclusively serving active military, Veterans, and first responders for PTSD, substance use, and co-occurring disorders, with locations in Texas and Virginia. Open 24/7.",
    notes:
      "Primary source: https://www.warriorsheart.com/ (checked 2026-03-15). Note: also accepts VA referrals. Admissions line: (877) 660-3263. No public email; contact via web form.",
  },
  {
    id: 127,
    name: "Project Sanctuary",
    category: "Mental Health and SUD",
    counties: ["All"],
    address: "P.O. Box 1563, Granby, CO 80446",
    phone: "(855) 838-8255",
    website: "https://projectsanctuary.us/",
    email: "info@projectsanctuary.us",
    services: [
      "Therapeutic activities",
      "Family retreat programs",
      "Wellness plans and counseling",
      "Community resources and support",
    ],
    description:
      "Provides free 6-day therapeutic retreats for military families followed by two years of family support services, treating the entire family to help Veterans, spouses, caregivers, and children heal together.",
    notes:
      "Primary source: https://projectsanctuary.us/ (checked 2026-03-15). Note: retreat inquiries can also be sent to retreats@projectsanctuary.us.",
  },
  {
    id: 128,
    name: "Disabled Veterans National Foundation (DVNF)",
    category: "Benefits, Claims, and Financial Assistance",
    counties: ["All"],
    address: "4601 Forbes Blvd., Suite #130, Lanham, MD 20706",
    phone: "(202) 737-0522",
    website: "https://www.dvnf.org/",
    email: "info@dvnf.org",
    services: [
      "Emergency financial assistance grants",
      "Food assistance programs",
      "Homeless-to-housing transition grants",
      "Community resources and support",
    ],
    description:
      "Provides critically needed support to disabled and at-risk Veterans through grant programs including Grants to Provide Stability (up to $1,000 for housing/utilities), a Veteran Food Assistance Program, and Homeless to Housing aid (up to $2,000).",
    notes:
      "Primary source: https://www.dvnf.org/contact-us/ (checked 2026-03-15). Note: donation line: 1-888-782-2148.",
  },
  {
    id: 129,
    name: "Bob Woodruff Foundation – Got Your 6 Network Directory",
    category: "Online Resources and Support Groups",
    counties: ["All"],
    address: "1350 Broadway Suite 905, New York, NY 10018",
    phone: "(646) 905-5610",
    website: "https://bobwoodrufffoundation.org/our-partners/veteran-serving-organizations/got-your-6-network/got-your-6-network-directory/",
    email: "info@BobWoodruffFoundation.org",
    services: [
      "Searchable directory of veteran-serving organizations",
      "Location and service filters",
      "Connections to community support providers",
    ],
    description: "Nationwide directory connecting veterans, service members, families, and caregivers with organizations in the Got Your 6 Network. Search by location and need to find support available in New Hampshire.",
    notes: "This listing is a referral directory, not a general direct financial-aid application. Eligibility and availability are determined by each listed provider.",
  },
  {
    id: 130,
    name: "Elizabeth Dole Foundation / Hidden Heroes",
    category: "Benefits, Claims, and Financial Assistance",
    counties: ["All"],
    address: "",
    phone: "(202) 249-7170",
    website: "https://hiddenheroes.org/",
    email: "info@elizabethdolefoundation.org",
    services: [
      "Caregiver support and respite care",
      "Emergency financial assistance",
      "Peer support networks",
      "Community resources and support",
    ],
    description:
      "Supports military and Veteran caregivers through the Hidden Heroes campaign, providing financial assistance, fellowship programs, respite care, and peer support to the millions of Americans caring for wounded, ill, or injured service members and Veterans.",
    notes:
      "Primary source: https://hiddenheroes.org/contact-us/ (checked 2026-03-15). Note: financial support inquiries: financialsupport@elizabethdolefoundation.org.",
  },
  {
    id: 131,
    name: "Boots to Business (SBA)",
    category: "Employment and Career Services",
    counties: ["All"],
    address:
      "409 3rd St. SW, Suite 5700, Washington, DC 20416 (SBA Office of Veterans Business Development)",
    phone: "(202) 205-8381",
    website: "https://www.sba.gov/counseling/boots-to-business/",
    email: "boots-to-business@sba.gov",
    services: [
      "Entrepreneurial training for veterans",
      "Business ownership education",
      "Financial planning workshops",
      "Career guidance",
    ],
    description:
      "SBA entrepreneurial training program offering free workshops and courses on business ownership, financial planning, and marketing for transitioning service members, Veterans, and military spouses.",
    notes:
      "Official SBA program page. General veterans business inquiries: veteransbusiness@sba.gov, (202) 205-6773.",
  },
  {
    id: 132,
    name: "IVMF Entrepreneurship Programs (formerly Bunker Labs)",
    category: "Employment and Career Services",
    counties: ["All"],
    address: "",
    phone: "",
    website: "https://ivmf.syracuse.edu/programs/entrepreneurship/",
    email: "",
    services: [
      "Military Founders Lab virtual start-up program",
      "CEOcircle and other growth-stage programs",
      "Business mentorship and peer networking",
      "Resources for veteran and military-spouse entrepreneurs",
    ],
    description:
      "IVMF’s current entrepreneurship portfolio provides training, mentorship, peer networks, and business-development resources for veterans and military spouses nationwide.",
    notes:
      "Bunker Labs was acquired by IVMF in January 2024. Bunker Build Up, Veterans in Residence, and Breaking Barriers were subsequently consolidated into Military Founders Lab, while other IVMF entrepreneurship programs continue separately.",
  },
  {
    id: 133,
    name: "DAV Patriot Boot Camp",
    category: "Employment and Career Services",
    counties: ["All"],
    address: "860 Dolwick Drive, Erlanger, KY 41018 (DAV National HQ)",
    phone: "",
    website: "https://patriotbootcamp.org/",
    email: "patriotbootcamp@dav.org",
    services: [
      "Entrepreneurship education and pitch competitions",
      "Business mentorship with industry experts",
      "Startup resources for veteran-owned businesses",
      "Career guidance",
    ],
    description:
      "Free 3-day entrepreneurship events providing Veterans, service members, and military spouses with startup education, one-on-one mentorship from leading business experts, networking, and pitch competitions with non-dilutive funding.",
    notes:
      "Primary source: https://patriotbootcamp.org/ (checked 2026-03-15).",
  },
  {
    id: 134,
    name: "Final Salute Inc.",
    category: "Housing and Homelessness Assistance",
    counties: ["All"],
    address: "2800 Eisenhower Ave, Suite 220, Alexandria, VA 22314",
    phone: "",
    website: "https://www.finalsaluteinc.org/Home.html",
    email: "donations@finalsaluteinc.org",
    services: [
      "Emergency and transitional housing",
      "Housing for homeless women veterans",
      "Financial education and savings programs",
      "Employment support and professional development",
    ],
    description:
      "Provides homeless women Veterans and their children with safe and suitable housing through the H.O.M.E. program (transitional housing, childcare, employment support), S.A.F.E. program (financial education), and Next Uniform program (career clothing and resources).",
    notes:
      "Primary source: https://www.finalsaluteinc.org/ (checked 2026-03-15). Note: no public phone listed; contact via email or web form. Mailing: P.O. Box 156, Haymarket, VA 20168.",
  },
  {
    id: 135,
    name: "Swords to Plowshares",
    category: "Online Resources and Support Groups",
    counties: ["All"],
    address: "1060 Howard Street, San Francisco, CA 94103",
    phone: "(415) 252-4788",
    website: "https://www.swords-to-plowshares.org/",
    email: "",
    services: [
      "Veteran legal self-help guides",
      "Discharge-upgrade resources",
      "Toolbox.vet resource library",
      "Information about Bay Area direct services",
    ],
    description:
      "Veteran rights organization whose online self-help guides and resource library are available nationally; its direct legal, housing, employment, and benefits services are limited to the San Francisco Bay Area.",
    notes:
      "This listing is for online information only for New Hampshire users. Direct client services are limited to Veterans living in the Greater San Francisco Bay Area.",
  },
  {
    id: 136,
    name: "Hope For The Warriors",
    category: "Veteran Service Organizations and Advocacy",
    counties: ["All"],
    address: "8003 Forbes Place, Suite 201, Springfield, VA 22151",
    phone: "(877) 246-7349",
    website: "https://www.hopeforthewarriors.org/",
    email: "info@hopeforthewarriors.org",
    services: [
      "Mental health & substance use treatment",
      "Career transition assistance",
      "Emergency financial assistance",
      "Community programs",
    ],
    description:
      "National nonprofit restoring stability, strength, and community for post-9/11 Veterans, service members, and military families through health, wellness, career transition, and financial support programs. Has served over 187,000 individuals.",
    notes:
      "Primary source: https://www.hopeforthewarriors.org/about/contact-us/ (checked 2026-03-15). Mailing: PO Box 111935, Carrollton, TX 75011.",
  },
  {
    id: 137,
    name: "Outward Bound Veterans",
    category: "Mental Health and SUD",
    counties: ["All"],
    address: "4 Airline Drive, Suite 202, Albany, NY 12205",
    phone: "(866) 467-7651",
    website:
      "https://www.outwardbound.org/find-a-program/enroll-in-a-course/veterans/",
    email: "",
    services: [
      "Outdoor recreation programs",
      "Therapeutic activities",
      "Peer support networks",
      "Wellness plans and counseling",
    ],
    description:
      "Provides free wilderness courses designed to help Veterans readjust to life after service, using teamwork, challenge, and the natural world for healing. Tuition is fully funded for Veterans and eligible active-duty service members.",
    notes:
      "Primary source: https://www.outwardbound.org/find-a-program/enroll-in-a-course/veterans/ (checked 2026-03-15). Note: $50 commitment fee at enrollment, waivers available by calling admissions. Many schools also cover travel costs for combat Veterans.",
  },
  {
    id: 138,
    name: "Sierra Club Military Outdoors",
    category: "Veteran Service Organizations and Advocacy",
    counties: ["All"],
    address: "",
    phone: "(415) 977-5500",
    website: "https://www.sierraclub.org/military-outdoors",
    email: "military.outdoors@sierraclub.org",
    services: [
      "Outdoor recreation programs",
      "Community-building events",
      "Therapeutic activities",
      "Community resources and support",
    ],
    description:
      "Sierra Club program providing outdoor trips and experiences led by former service members for military members, Veterans, and their families, focused on removing barriers to enjoying nature and building community.",
    notes:
      "Primary source: https://www.sierraclub.org/military-outdoors (checked 2026-03-15). Note: Sierra Club HQ phone listed; program-specific contact via email.",
  },
  {
    id: 139,
    name: "American Red Cross Military & Veteran Caregiver Network",
    category: "Veteran Service Organizations and Advocacy",
    counties: ["All"],
    address: "",
    phone: "(877) 272-7337",
    website:
      "https://www.redcross.org/get-help/military-families/whole-health/military-veteran-caregiver-network.html",
    email: "info.mvcn@redcross.org",
    services: [
      "Peer support networks",
      "Caregiver support and education",
      "Community resources and support",
      "Wellness plans and counseling",
    ],
    description:
      "Red Cross peer support program for military and Veteran caregivers, offering online and community-based peer support groups, peer mentor programs, and workshops to reduce isolation and build resilience.",
    notes:
      "Primary source: https://www.redcross.org/get-help/military-families/whole-health/military-veteran-caregiver-network.html (checked 2026-03-15). Note: text GETHEROCARE to 90999 for support. Phone is Hero Care specialist line.",
  },
  {
    id: 140,
    name: "Homeland Heroes Foundation",
    category: "Housing and Homelessness Assistance",
    counties: ["All"],
    address: "10 Delaware Dr, Suite 1, Salem, NH 03079",
    phone: "(603) 458-1275",
    website: "https://homelandheroesfoundation.org/",
    email: "info@homelandheroesfoundation.org",
    services: [
      "Furniture and household item donations",
      "Emergency and transitional housing",
      "Community resources and support",
      "Community programs",
    ],
    description:
      "New England nonprofit serving Veterans and active duty service members in NH, MA, ME, and VT by providing furniture, household items, temporary housing, and supportive services to help Veterans in transition make a house a home.",
    notes:
      "Primary source: https://homelandheroesfoundation.org/contact-us/ (checked 2026-03-15).",
  },
  {
    id: 141,
    name: "Brain Injury Association of New Hampshire (BIANH)",
    category: "Mental Health and SUD",
    counties: ["All"],
    address: "52 Pleasant Street, Concord, NH 03301",
    phone: "(603) 225-8400",
    website: "https://bianh.org/",
    email: "mail@bianh.org",
    services: [
      "Traumatic brain injury support and education",
      "Veteran-specific TBI resources",
      "Community resources and support",
      "Community outreach",
    ],
    description:
      "NH-based nonprofit representing over 5,000 residents with acquired or traumatic brain injuries, with specific programming for Veterans given that blasts are the leading cause of TBI among service members who served in Iraq and Afghanistan.",
    notes:
      "Primary source: https://bianh.org/contact-us (checked 2026-03-15). Note: toll-free Brain Injury Info line: 1-800-444-6443. Veteran-specific site: https://nh-veteran.com/.",
  },
  {
    id: 142,
    name: "VA CHAMPVA (Civilian Health and Medical Program)",
    category: "Benefits, Claims, and Financial Assistance",
    counties: ["All"],
    address: "PO Box 137, Spring City, PA 19475",
    phone: "(800) 733-8387",
    website:
      "https://www.va.gov/family-and-caregiver-benefits/health-and-disability/champva/",
    email: "",
    services: [
      "Healthcare coverage for dependents of disabled veterans",
      "Benefits counseling",
      "Community resources and support",
      "Assistance with benefits, housing, and mental health resources",
    ],
    description:
      "VA health care benefits program for the spouse, dependent, or surviving family member of a Veteran who has been rated permanently and totally disabled from a service-connected condition, or who died from a service-connected disability.",
    notes:
      "Primary source: https://www.va.gov/COMMUNITYCARE/programs/dependents/champva/ (checked 2026-03-15). Note: phone hours M-F 8am-7:30pm ET. Apply via VA Form 10-10d or use Ask VA for inquiries.",
  },
  {
    id: 143,
    name: "VA Bereavement Counseling (Vet Centers)",
    category: "Crisis Support",
    counties: ["All"],
    address: "",
    phone: "(877) 927-8387",
    website: "https://www.va.gov/burials-memorials/bereavement-counseling/",
    email: "",
    services: [
      "Bereavement and grief counseling",
      "Individual and group counseling",
      "Community resources and support",
      "Telehealth services available",
    ],
    description:
      "Free, confidential grief counseling through VA Vet Centers for families of service members who died in service, Veterans who died by suicide, and other eligible survivors. Available 24/7 by phone and through over 300 community Vet Centers nationwide.",
    notes: "The Vet Center call center is available 24/7 at the listed number. Counseling appointments and eligibility are arranged with a Vet Center; TTY: 711.",
  },
  {
    id: 144,
    name: "VA Center for Women Veterans",
    category: "Veteran Service Organizations and Advocacy",
    counties: ["All"],
    address:
      "810 Vermont Avenue NW, Washington, DC 20420",
    phone: "(202) 461-6193",
    website: "https://department.va.gov/center-for-women-veterans/",
    email: "00w@va.gov",
    services: [
      "Women veteran advocacy and policy",
      "Community resources and support",
      "Benefits counseling",
      "Comprehensive resource directory",
    ],
    description:
      "VA office serving as the primary advisor on policies, programs, and services for women Veterans, providing a central resource hub and advocacy for the unique needs of women who have served in the military.",
    notes:
      "Women Veterans Call Center for direct assistance: 1-855-829-6636 (call or text).",
  },
  {
    id: 145,
    name: "FedsHireVets (OPM)",
    category: "Employment and Career Services",
    counties: ["All"],
    address: "",
    phone: "",
    website: "https://www.opm.gov/fedshirevets/",
    email: "",
    services: [
      "Federal employment resources for veterans",
      "Job placement services",
      "Career guidance",
      "Comprehensive resource directory",
    ],
    description:
      "Federal government's official portal for Veteran employment, providing resources on federal hiring preferences, job listings, and guidance for Veterans, transitioning service members, and military spouses seeking federal careers.",
    notes:
      "Primary source: https://www.opm.gov/fedshirevets/ (checked 2026-03-15). Note: no direct phone/email; Veterans should contact agency-specific Veteran Employment Program Offices listed on site.",
  },
  {
    id: 146,
    name: "Veterans Business Outreach Center of New England",
    category: "Employment and Career Services",
    counties: ["All"],
    address: "69 Milk St, Suite 217, Westborough, MA 01581",
    phone: "(844) 582-2461",
    website: "https://vbocnewengland.org/",
    email: "info.vboc@vbocnewengland.org",
    services: [
      "Small business training and counseling",
      "Business mentorship and networking",
      "Entrepreneurial training for veterans",
      "Career guidance",
    ],
    description:
      "SBA-funded New England center providing free entrepreneurial development, training, counseling, and mentorship for Veterans, service members, National Guard and Reserve members, and military spouses.",
    notes:
      "The New England VBOC serves Connecticut, Maine, Massachusetts, New Hampshire, Rhode Island, and Vermont.",
  },
  {
    id: 147,
    name: "Live Free Recovery (Manchester & Keene)",
    category: "Mental Health and SUD",
    counties: ["All", "Hillsborough", "Cheshire"],
    address: "500 Commercial St, Manchester, NH 03101; 21 West St, Keene, NH 03431",
    phone: "(888) 705-3759",
    website: "https://livefreerecoverynh.com/",
    email: "",
    services: [
      "Medical Detox",
      "Residential Treatment",
      "Partial Hospitalization (PHP)",
      "Intensive Outpatient (IOP)",
      "Outpatient",
      "Sober Living",
    ],
    description:
      "Full-continuum addiction and mental health treatment center with locations in Manchester and Keene, offering medical detox through sober living. In-network with the VA Community Care Network for service-connected Veterans.",
    notes:
      "Admissions via toll-free line. Accepts VA Community Care referrals for eligible service-connected Veterans.",
  },
  {
    id: 148,
    name: "Home Base – New England Veteran and Family Programs",
    category: "Mental Health and SUD",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "One Constitution Wharf, Suite 140, Charlestown, MA 02129",
    phone: "(617) 724-5202",
    website: "https://homebase.org/programs/new-england-programs/",
    email: "homebaseprogram@partners.org",
    services: [
      "No-cost veteran and service-member mental health care",
      "Individual and group outpatient therapy",
      "Family care and support",
      "Veteran wellness and resiliency programs",
      "Care navigation and intensive clinical program screening",
    ],
    description:
      "New England clinical and wellness programs addressing PTSD, depression, anxiety, brain injury, and related invisible wounds for Veterans, Service Members, and families.",
    notes:
      "Care is offered without regard to service era or discharge status. Some clinical programs require travel or have state-specific eligibility; confirm during intake.",
  },
  {
    id: 149,
    name: "VA Legal Services for Veterans (LSV-H)",
    category: "Legal Services",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "",
    website:
      "https://department.va.gov/homeless/legal-services-for-veterans/",
    email: "",
    services: [
      "Current legal-services grantee referral directory",
      "Housing-stability legal assistance",
      "Benefits and income-support legal assistance",
      "Discharge-upgrade and employment-law referrals",
      "Family-law and domestic-violence legal referrals",
    ],
    description:
      "VA referral pathway connecting eligible homeless or at-risk Veterans with funded civil legal-service providers.",
    notes:
      "Availability and covered matters vary by grantee; use the current referral list and confirm New Hampshire coverage.",
  },
  {
    id: 150,
    name: "VA Program of Comprehensive Assistance for Family Caregivers (PCAFC)",
    category: "Government Agencies and Services",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "1-855-260-3274",
    website:
      "https://www.va.gov/family-and-caregiver-benefits/health-and-disability/comprehensive-assistance-for-family-caregivers/",
    email: "",
    services: [
      "Monthly stipend for eligible primary family caregivers",
      "Caregiver education and mental health counseling",
      "Respite care and certain travel benefits",
      "CHAMPVA eligibility for some primary caregivers",
      "Online, mail, or in-person application pathway",
    ],
    description:
      "VA benefit program providing enhanced clinical support and benefits to approved family caregivers of eligible Veterans who need ongoing in-person personal care.",
    notes:
      "The Veteran and caregiver apply together using VA Form 10-10CG. Eligibility includes a VA disability rating of 70% or higher, VA health-care enrollment, and a need for at least six months of continuous in-person personal care. Caregiver Support Line hours are Monday through Friday, 8 a.m.–8 p.m. ET.",
  },
  {
    id: 151,
    name: "VA VET TEC 2.0 High-Tech Training Program",
    category: "Employment and Career Services",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "1-888-442-4551",
    website:
      "https://www.va.gov/education/other-va-education-benefits/vet-tec-2/",
    email: "",
    services: [
      "Short-term high-tech career training",
      "Tuition and fees paid to approved providers",
      "Housing allowance",
      "Books and supplies stipend",
      "Employment assistance after training",
    ],
    description:
      "VA education benefit for eligible Veterans and service members seeking non-degree training in computer programming, software, data processing, information sciences, or media applications.",
    notes:
      "Applicants generally must have at least 36 months of active-duty service, be under age 62 when approved, and have a discharge other than dishonorable or be within 180 days of separation. Annual participation is limited; check the VA page for current openings and approved providers before applying.",
  },
  {
    id: 152,
    name: "VA White River Junction Healthcare System",
    category: [
      "Government Agencies and Services",
      "Mental Health and SUD"
    ],
    counties: [
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan"
    ],
    address: "White River Junction, VT; serving Vermont and northwestern New Hampshire",
    phone: "",
    website: "https://www.va.gov/white-river-junction-health-care/health-services/",
    email: "",
    services: [
      "Veteran mental health treatment",
      "Addiction-related care",
      "PTSD counseling",
      "Women Veterans care",
      "Suicide-prevention care coordination"
    ],
    description: "VA healthcare system with an explicit service area including northwestern New Hampshire, providing an additional care pathway beyond the Manchester VA system.",
    notes: "Use the official service pages to find the appropriate clinic and appointment pathway. VA eligibility and referral rules apply; services vary by location. For an immediate crisis, call 988 and press 1."
  },
  {
    id: 153,
    name: "Veteran Pathways of New England (formerly Clear Path for Veterans New England)",
    category: [
      "Housing and Homelessness Assistance",
      "Veteran Service Organizations and Advocacy"
    ],
    counties: [
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan"
    ],
    address: "",
    phone: "",
    website: "https://www.veteranpathwaysne.org/housing-partnerships/",
    email: "",
    services: [
      "Veteran housing stabilization",
      "Case management and coordinated referrals",
      "Benefits and healthcare navigation",
      "Military family support"
    ],
    description: "Regional veteran organization providing housing stabilization and coordinated support across Massachusetts and New Hampshire.",
    notes: "Use the organization's contact or Join the Veteran Community pathway to request assistance. NH access is explicitly described on the official site; individual housing and financial-assistance programs have their own eligibility requirements."
  },
  {
    id: 154,
    name: "True North Healing Center – Veterans and First Responders",
    category: "Mental Health and SUD",
    counties: [
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan"
    ],
    address: "40 South River Road, Unit 53, Bedford, NH 03110; 149 Hanover Street, Suite 200, Manchester, NH 03101",
    phone: "(603) 696-4872",
    website: "https://truenorthhealingcenter.com/",
    email: "",
    services: [
      "Veteran-focused trauma therapy",
      "EMDR therapy",
      "Individual psychotherapy",
      "Telehealth throughout New Hampshire"
    ],
    description: "New Hampshire therapy practice with a specific offering for veterans and first responders affected by trauma and chronic stress.",
    notes: "In-person care in Bedford and Manchester; telehealth across NH. The practice lists VA Community Care and several private insurance plans. Confirm coverage and any required VA authorization before scheduling. Services are not universally free."
  },
  {
    id: 155,
    name: "VA Solid Start (VASS)",
    category: [
      "Government Agencies and Services",
      "Benefits, Claims, and Financial Assistance",
    ],
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "(800) 827-0611",
    website: "https://www.va.gov/service-member-benefits/solid-start/",
    email: "",
    services: [
      "Transition outreach during the first year after separation",
      "VA benefits and health-care navigation",
      "Housing, education, and employment referrals",
      "Mental-health and crisis-support connections",
    ],
    description:
      "VA outreach program for transitioning service members and recently separated veterans, with contacts during the first year after separation.",
    notes:
      "VA attempts contact during days 0–90, 91–180, and 181–365 after separation. Phone support is available Monday through Friday.",
  },
  {
    id: 156,
    name: "Northeast Passage – Veteran Recreation",
    category: "Mental Health and SUD",
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "121 Technology Dr, Suite 161, Durham, NH 03824",
    phone: "(603) 862-0070",
    website: "https://www.nepassage.org/veteran-recreation",
    email: "northeast.passage@unh.edu",
    services: [
      "Veteran-specific adaptive recreation",
      "Outdoor and seasonal group activities",
      "Adaptive sports",
      "Peer connection and recreational therapy",
    ],
    description:
      "University of New Hampshire program offering veteran-specific and adaptive recreation for veterans and active-duty service members of all eras and ability levels.",
    notes:
      "Most veteran options are provided at no cost. Review the current event calendar and registration requirements.",
  },
  {
    id: 157,
    name: "Veterans Yoga Project – Free Online Studio",
    category: [
      "Mental Health and SUD",
      "Online Resources and Support Groups",
    ],
    counties: [
      "All",
      "Belknap",
      "Carroll",
      "Cheshire",
      "Coös",
      "Grafton",
      "Hillsborough",
      "Merrimack",
      "Rockingham",
      "Strafford",
      "Sullivan",
    ],
    address: "",
    phone: "",
    website: "https://veteransyogaproject.org/vyp-classes/",
    email: "vypstudio@veteransyogaproject.org",
    services: [
      "Free daily live yoga and mindfulness classes",
      "On-demand practice library",
      "Trauma-informed mindful-resilience practices",
      "In-person class finder",
    ],
    description:
      "Nationwide program providing free online resilience, yoga, breathwork, and mindfulness programming for veterans, service members, military families, caregivers, and supporters.",
    notes:
      "A free account is required for live classes. This wellness program is not a substitute for crisis or clinical mental-health care.",
  },
];
